<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Nyilvántartás</ion-title>
    <!--ion-buttons slot="end">
      <ion-button color="primary">
        <ion-icon slot="icon-only" name="create"></ion-icon>
      </ion-button>
      <ion-button color="danger">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button>
    </ion-buttons-->
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="sajatIntezmeny">
  <ion-grid class="hide-on-mobile">
    <ion-row>
      <!-- 1200 px alatt a Statisztika a Beállítások alá kerül, így nem szorul össze. -->
      <ion-col size="12" size-xl="8">
        <ion-card *ngIf="user$" style="height: 100%">
          <ion-card-header>
            <ion-card-title>Beállítások</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-grid>
              <ion-row>
                <ion-col>
                  <!--ion-item-->
                  <ion-input fill="outline" label="Tárgyév" labelPlacement="stacked" type="text" placeholder="2023"
                    [(ngModel)]="selectedYearS" (ngModelChange)="valasztoValtozott()"></ion-input>
                  <!--/ion-item-->
                </ion-col>
                <ion-col *ngIf="selectedMonth && selectedMonthS">
                  <!--ion-item *ngIf="selectedMonth"-->
                  <!--label>Tárgyhónap:&nbsp;</label-->
                  <div class="honap-lepteto">
                  <ion-button fill="clear" size="small" title="Előző hónap" aria-label="Előző hónap"
                    (click)="honapLep(-1)">
                    <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
                  </ion-button>
                  <ion-select fill="outline" interface="popover" label="Tárgyhónap" labelPlacement="stacked"
                    name="selectedMonth" [(ngModel)]="selectedMonthS" (ngModelChange)="valasztoValtozott()"
                    [value]="selectedMonthS"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
                    <ion-select-option value="1">Január</ion-select-option>
                    <ion-select-option value="2">Február</ion-select-option>
                    <ion-select-option value="3">Március</ion-select-option>
                    <ion-select-option value="4">Április</ion-select-option>
                    <ion-select-option value="5">Május</ion-select-option>
                    <ion-select-option value="6">Június</ion-select-option>
                    <ion-select-option value="7">Július</ion-select-option>
                    <ion-select-option value="8">Augusztus</ion-select-option>
                    <ion-select-option value="9">Szeptember</ion-select-option>
                    <ion-select-option value="10">Október</ion-select-option>
                    <ion-select-option value="11">November</ion-select-option>
                    <ion-select-option value="12">December</ion-select-option>
                  </ion-select>
                  <ion-button fill="clear" size="small" title="Következő hónap" aria-label="Következő hónap"
                    (click)="honapLep(1)">
                    <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
                  </ion-button>
                  </div>
                  <!--/ion-item-->
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <!--ion-item (click)="select.open()" *ngIf="
                      userMetadata &&
                      (userMetadata.department == 'igazgató' ||
                        userMetadata.department == 'igazgatóhelyettes' ||
                        userMetadata.department == 'kancellár' ||
                        userMetadata.department == 'munkaügyi csoportvezető' ||
                        userMetadata.department == 'admin' ||
                          userMetadata.department == 'rendszergazda' ||
                          userMetadata.department == 'iskolatitkár')
                    ">
                    <label>Munkavállaló:&nbsp;</label>
                    <!--ionic-selectable
                      (click)="loadMunkatars()"
                      item-content
                      [(ngModel)]="port"
                      [items]="ports"
                      itemValueField="id"
                      itemTextField="name"
                      [canSearch]="true"
                      [canClear]="true"
                      closeButtonText="Mégse"
                      [searchFailText]="'Nincs találat / Adatok lekérése'"
                      [searchPlaceholder]="'Keresés'"
                      [hasInfiniteScroll]="true"
                      (onChange)="portChange($event)"
                      (onSearch)="searchPorts($event)"
                      (onInfiniteScroll)="getMorePorts($event)"
                      (onClear)="onClear()"
                      clearButtonText="Visszaállítás"
                    >
                    </ionic-selectable-->
                  <app-searchable-select (click)="select.open()" *ngIf="readWrite" #select
                    title="Munkavállaló kiválasztása" [data]="ports" [placeholderText]="sajatnev"
                    [itemTextField]="'name'" (selectedChanged)="selectChanged($event)" theme="new" [multiple]="false"
                    style="cursor:pointer"></app-searchable-select>
                  <!--/ion-item-->
                  <!--ion-item *ngIf="
                      !(
                        userMetadata &&
                        (userMetadata.department == 'igazgató' ||
                          userMetadata.department == 'igazgatóhelyettes' ||
                          userMetadata.department == 'kancellár' ||
                          userMetadata.department == 'munkaügyi csoportvezető' ||
                          userMetadata.department == 'admin' ||
                          userMetadata.department == 'rendszergazda' ||
                          userMetadata.department == 'iskolatitkár')
                      )
                    "-->
                  <ion-input *ngIf="!readWrite" label="Munkavállaló" fill="outline" labelPlacement="stacked" type="text"
                    placeholder="" [value]="sajatnev"></ion-input>
                  <!--/ion-item-->
                </ion-col>
              </ion-row><ion-row>

                <ion-col>
                  <!--ion-item (click)="select.open()">
                  <label>Intézmény:&nbsp;</label>
                  <app-searchable-select
                    #select
                    title="Intézmény kiválasztása"
                    [data]="intezmenyek"
                    [placeholderText]="sajatIntezmeny.intezmenyName"
                    [itemTextField]="'intezmenyName'"
                    (selectedChanged)="selectChangedIntezmeny($event)"
                    [multiple]="false"
                    style="cursor:pointer"
                  ></app-searchable-select>
                </ion-item-->
                  <!--ion-item-->
                  <ion-input style="display:none" label="Intézmény" type="text" placeholder="Válasszon intézményt"
                    fill="outline" labelPlacement="stacked" readonly [value]="sajatIntezmeny.intezmenyName"></ion-input>
                  <!--/ion-item-->
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <!--ion-item-->
                  <ion-button color="warning" *ngIf="isRobotJelenletAdmin() && isElozoHonap()" (click)="robotJelenlet()">
                    <ion-icon slot="start" name="sparkles-outline"></ion-icon>
                    Robotjelenlét
                  </ion-button>
                  <ion-button color="secondary" (click)="resetM()">
                    <ion-icon slot="start" name="refresh"></ion-icon>
                    Visszaállítás
                  </ion-button>
                  <!--/ion-item-->
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col size="12" size-xl="4">
        <ion-card style="height: 100%">
          <ion-card-header>
            <ion-card-title>Statisztika</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <!-- Csempék a régi négyoszlopos táblázat helyett: a keskeny kártyában is elférnek
                 (tördelődnek), vízszintes csúszka csak nagyon szűk képen kell. -->
            <div class="stats-scroll">
              <div class="stats-grid">
                <div class="stats-tile" title="Könyvelt napok">
                  <span class="stats-cimke">Könyvelt napok</span>
                  <span class="stats-ertek">{{ statsDisplay.bookedDays }}</span>
                </div>
                <div class="stats-tile" title="Hiányos napok">
                  <span class="stats-cimke">Hiányos napok</span>
                  <span class="stats-ertek">{{ statsDisplay.incompleteDays }}</span>
                </div>
                <div class="stats-tile" title="Óraszám">
                  <span class="stats-cimke">Óraszám</span>
                  <span class="stats-ertek">{{ statsDisplay.hours }}</span>
                </div>
                <div class="stats-tile" title="Kiküldetési rendelvény">
                  <span class="stats-cimke">Kiküldetési rendelvény</span>
                  <span class="stats-ertek">{{ statsDisplay.travelKm }} km</span>
                </div>
                <!--div class="stats-tile">
                  <span class="stats-cimke">ELVÁRT óraszám</span>
                  <span class="stats-ertek">{{(munkanapok*6.4).toFixed(2) }}</span>
                </div-->
                <div class="stats-tile" title="Rendelkezésre álló szabadság (zárójelben: a hónapban felhasznált)">
                  <span class="stats-cimke">Rendelkezésre álló szabadság</span>
                  <span class="stats-ertek">
                    {{ statsDisplay.remainingVacation }} ({{ statsDisplay.usedVacationInMonth }})
                  </span>
                </div>
                <div class="stats-tile" title="Rendelkezésre álló betegállomány (zárójelben: a hónapban felhasznált)">
                  <span class="stats-cimke">Rendelkezésre álló betegállomány</span>
                  <span class="stats-ertek">
                    {{ statsDisplay.remainingSickLeave }} ({{ statsDisplay.usedSickLeaveInMonth }})
                  </span>
                </div>
              </div>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid>
    <ion-row>
      <ion-col>




      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="hide-on-desktop">
        <!--MOBIL-->
        <ion-row>
          <ion-col>
            <span style="font-size:25px">Összesítő - {{ selectedMonth }}. hónap </span>
            <span style="float:right"><ion-button id="open-modal"><fa-icon icon="filter"></fa-icon></ion-button></span>
          </ion-col>
        </ion-row>
        <ion-segment [value]="weekNum" [scrollable]="true">
          <ion-segment-button [value]="idx+1" *ngFor="let item of weekCount(1); let idx = index"
            (click)="setWeekNum(idx+1)">
            <ion-label>hét</ion-label>
            <ion-icon [name]="'c-'+(idx+1)"></ion-icon>
          </ion-segment-button>
        </ion-segment>
        <ion-card style="margin-left: 0; margin-right: 0">
          <ion-card-content style="padding: 0 !important;">
            <ion-list [inset]="true">
              <ng-container *ngFor="let day of daysInMonth; index as idx">
                <ng-container
                  *ngIf="day.week == weekNum && !day.isHoliday && !day.isWeekend && day.nyilvantartas && today.getDate() + 1 > day.dayNumber">
                  <ion-item [button]="true" detail="false" (click)="initModal(day)">
                    <ion-icon [color]="statuszok[day.nyilvantartas.status][1]" slot="start"
                      [name]="statuszok[day.nyilvantartas.status][0]" size="large"></ion-icon>
                    <ion-label>
                      <strong>{{day.dayNumber}} - {{day.dayName}}</strong>
                      <ion-text>{{statuszok[day.nyilvantartas.status][2]}}</ion-text><br />
                      <ion-note color="medium" class="ion-text-wrap">

                      </ion-note>
                    </ion-label>
                    <div class="metadata-end-wrapper1" slot="end">
                      <ion-note color="medium"></ion-note>
                      <ion-icon color="medium" name="chevron-forward"></ion-icon>
                    </div>
                  </ion-item>
                </ng-container>
                <ng-container
                  *ngIf="day.week == weekNum && !day.isHoliday && !day.isWeekend && !day.nyilvantartas && today.getDate() + 1 > day.dayNumber">
                  <ion-item [button]="true" detail="false" (click)="initModal(day)">
                    <ion-icon [color]="statuszok[0][1]" slot="start" [name]="statuszok[0][0]" size="large"></ion-icon>
                    <ion-label>
                      <strong>{{day.dayNumber}} - {{day.dayName}}</strong>
                      <ion-text>{{statuszok[0][2]}}</ion-text><br />
                      <ion-note color="medium" class="ion-text-wrap">

                      </ion-note>
                    </ion-label>
                    <div class="metadata-end-wrapper1" slot="end">
                      <ion-note color="medium"></ion-note>
                      <ion-icon color="medium" name="chevron-forward"></ion-icon>
                    </div>
                  </ion-item>
                </ng-container>
                <ng-container
                  *ngIf="day.week == weekNum && !day.isHoliday && !day.isWeekend && today.getDate() + 1 <= day.dayNumber">
                  <ion-item [button]="true" detail="false" disabled>
                    <ion-icon [color]="statuszok[8][1]" slot="start" [name]="statuszok[8][0]" size="large"></ion-icon>
                    <ion-label>
                      <strong>{{day.dayNumber}} - {{day.dayName}}</strong>
                      <ion-text>{{statuszok[8][2]}}</ion-text><br />
                      <ion-note color="medium" class="ion-text-wrap">

                      </ion-note>
                    </ion-label>
                    <div class="metadata-end-wrapper1" slot="end">
                      <ion-note color="medium"></ion-note>
                      <ion-icon color="medium" name="chevron-forward"></ion-icon>
                    </div>
                  </ion-item>
                </ng-container>
              </ng-container>
            </ion-list>
          </ion-card-content>
        </ion-card>
      </ion-col><ion-col class="hide-on-mobile">
        <!--ASZTALI-->
        <ion-card>
          <ion-card-header>
            <!--  A cím és a gombok egy sorban (flex): a korábbi float-os gombok – a középső egy
                  span-ban – más alapvonalon álltak, nem voltak egy sorban. -->
            <ion-card-title class="osszesito-fej"><span>Összesítő - {{ selectedMonth }}.
                hónap</span>
              <span class="osszesito-gombok">
                <ion-button (click)="printData()" size="small" color="light" title="Nyomtatás">
                  <ion-icon slot="icon-only" name="print-outline"></ion-icon>
                </ion-button>
                <!-- #1068: könyveletlen óra mellett a saját elszámolás zárva; a letiltott gomb nem
                     mutat súgót, ezért a burkoló span viseli a magyarázatot. -->
                <span class="osszesito-gomb-burok" [title]="munkaidoEll?.konyveletlen ? munkaidoEll?.uzenet : 'Havi munkaidő-elszámolás napi bontásban, a KRÉTA-lap mintájára (PDF)'">
                  <ion-button (click)="munkaidoElszamolas()" size="small" color="light" [disabled]="munkaidoEll?.tilt">
                    <ion-icon slot="start" [name]="munkaidoEll?.konyveletlen ? 'warning-outline' : 'document-text-outline'"
                              [color]="munkaidoEll?.konyveletlen ? 'warning' : undefined"></ion-icon>
                    Munkaidő-elszámolás
                    <span *ngIf="munkaidoEll?.konyveletlen" style="margin-left:4px; font-size:11px; opacity:.8;">({{ munkaidoEll?.konyveletlen }} könyveletlen)</span>
                  </ion-button>
                </span>
                <ion-button size="small" color="light" (click)="initTanmenet()">
                  <ion-icon slot="start" name="duplicate"></ion-icon>
                  Tanmenet feltöltése
                </ion-button>
              </span>
            </ion-card-title>
          </ion-card-header>
          <ion-card-content>

            <!--div style="text-align: center">
        <ion-chip>
          <ion-icon name="alert" color="danger"></ion-icon>
          <ion-label>Nincs adat</ion-label>
        </ion-chip>
        <ion-chip>
          <ion-icon name="bed" color="tertiary"></ion-icon>
          <ion-label>Fizetett szabadság</ion-label>
        </ion-chip>
        <ion-chip>
          <ion-icon name="medkit" color="warning"></ion-icon>
          <ion-label>Betegszabadság / táppénz</ion-label>
        </ion-chip>
        <ion-chip>
          <ion-icon name="globe" color="secondary"></ion-icon>
          <ion-label>Digitális távoktatás</ion-label>
        </ion-chip>
        <ion-chip>
          <ion-icon name="car" color="secondary"></ion-icon>
          <ion-label>Iskolai kiküldetés</ion-label>
        </ion-chip>
        <ion-chip>
          <ion-icon name="ban" color="dark"></ion-icon>
          <ion-label>Fizetés nélküli szabadság</ion-label>
        </ion-chip>
        <ion-chip>
          <ion-icon name="leaf" color="success"></ion-icon>
          <ion-label>Nincs tanítási órám</ion-label>
        </ion-chip>
      </div-->



            <div class="scrollable-table">
              <table id="printable">
                <thead>
                  <tr>
                    <th>Dátum</th>
                    <th>Jelenlét</th>
                    <th class="hide-on-mobile">Érkezés</th>
                    <th class="hide-on-mobile">Távozás</th>
                    <th class="hide-on-mobile">
                      Óraszám
                    </th>
                    <th class="hide-on-mobile">
                      Könyvelt órák
                    </th>
                    <th class="hide-on-mobile">
                      Helyettesítés (eseti / tartós / kötött túlóra)
                    </th>
                    <th>Műveletek</th>
                    <th>Óraszám</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let day of daysInMonth; index as idx">
                    <tr>
                      <td>{{ day.dayNumber }} - {{ day.dayName }}</td>

                      <ng-container
                        *ngIf="today.getMonth() + 1 == selectedMonth && today.getFullYear() == selectedYear">
                        <!--A MOSTANI HÓNAP-->
                        <ng-container *ngIf="!(today.getDate() + 1 <= day.dayNumber && !day.nyilvantartas)">
                          <!--MÁTÓL VISSZAFELE-->
                          <ng-container *ngIf="!day.isWeekend && !day.isHoliday">
                            <!--NEM HÉTVÉGE-->
                            <ng-container *ngIf="day.nyilvantartas">
                              <!--LÉTEZIK NYILVÁNTARTÁS-->
                              <td *ngIf="day.nyilvantartas.status == 1 && isNapTeljes(day.nyilvantartas, day.dayDate)" style="
                          background-color: var(--ion-color-success-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        " [title]="napGyorsEllenorzesUzenet(day.nyilvantartas, day.dayDate)">
                                <ion-icon name="checkmark-outline"></ion-icon>
                              </td>
                              <td *ngIf="isKitoltetlenJelenlet(day.nyilvantartas) || isNapReszleges(day.nyilvantartas, day.dayDate)" style="
                          background-color: #f59e0b;
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        " [title]="napGyorsEllenorzesUzenet(day.nyilvantartas, day.dayDate)">
                                <ion-icon name="alert-circle-outline"></ion-icon>
                              </td>

                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 1"
                                style="text-align: center">
                                {{ day.nyilvantartas.start | date : "HH:mm" : "GMT" }}
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 1"
                                style="text-align: center">
                                {{ day.nyilvantartas.end | date : "HH:mm" : "GMT" }}
                              </td>

                              <!-- ÓRASZÁM és KÖNYVELT ÓRÁK: az órarendből (aznapi órák, ebből hány
                                   könyvelt) – korábban egy soha ki nem töltött pipa-mező állt itt. -->
                              <td *ngIf="day.nyilvantartas.status == 1" style="text-align: center; font-weight: 600">
                                {{ napiOra(day).relevans }}
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 1" style="text-align: center; font-weight: 600"
                                  [style.color]="napiOra(day).relevans === 0 ? '' : (napiOra(day).naplozott >= napiOra(day).relevans ? 'var(--ion-color-success-shade)' : 'var(--ion-color-warning-shade)')"
                                  [title]="napiOra(day).naplozott < napiOra(day).relevans ? 'Még ' + (napiOra(day).relevans - napiOra(day).naplozott) + ' óra könyveletlen' : ''">
                                {{ napiOra(day).naplozott }}
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 1"
                                style="text-align: center">
                                {{ getNapiHelyettesitesOsszesites(day).eseti }} /
                                {{ getNapiHelyettesitesOsszesites(day).tartos }} /
                                {{ getNapiHelyettesitesOsszesites(day).kotottTulora }}
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 2" style="
                          background-color: var(--ion-color-tertiary-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="bed-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 2" style="
                          background-color: var(--ion-color-tertiary-shade);
                          text-align: center;
                          color: white;
                        " colspan="5">
                                Fizetett szabadság
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 3" style="
                          background-color: var(--ion-color-warning-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="medkit-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 3" style="
                          background-color: var(--ion-color-warning-shade);
                          text-align: center;
                          color: white;
                        " colspan="5">
                                Betegszabadság / táppénz
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 7" style="
                          background-color: var(--ion-color-secondary-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="globe-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 7" style="
                          background-color: var(--ion-color-secondary-shade);
                          text-align: center;
                          color: white;
                        " colspan="5">
                                Digitális távoktatás / Home Office
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 4" style="
                          background-color: var(--ion-color-secondary-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="car-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 4" style="
                          background-color: var(--ion-color-secondary-shade);
                          text-align: center;
                          color: white;
                        " colspan="5">
                                Iskolai kiküldetés
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 5" style="
                          background-color: var(--ion-color-light-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="ban-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 5" style="
                          background-color: var(--ion-color-light-shade);
                          text-align: center;
                          color: white;
                        " colspan="5">
                                Fizetés nélküli szabadság
                              </td>
                              <td *ngIf="day.nyilvantartas.status == 6" style="
                          background-color: var(--ion-color-success-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="leaf-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 6" style="
                          background-color: var(--ion-color-success-shade);
                          text-align: center;
                          color: white;
                        " colspan="5">
                                Nincs tanítási órám
                              </td>
                            </ng-container>
                            <ng-container *ngIf="!day.nyilvantartas">
                              <!--NINCS NYILVÁNTARTÁS-->
                              <td style="
                          background-color: var(--ion-color-danger-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        ">
                                <ion-icon name="alert-circle-outline"></ion-icon>
                              </td>
                              <td class="hide-on-mobile" style="text-align: center" colspan="5">
                                Nincs adat
                              </td>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="day.isWeekend || day.isHoliday">
                            <!--HÉTVÉGE-->
                            <td style="
                        background-color: var(--ion-color-light);
                        text-align: center;
                        font-size: 25px;
                      ">
                              <ion-icon name="close-circle-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" style="text-align: center" colspan="5">
                              Munkaszüneti nap
                            </td>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="today.getDate() + 1 <= day.dayNumber && !day.nyilvantartas">
                          <!--JÖVŐ-->
                          <td style="
                      background-color: var(--ion-color-light);
                      text-align: center;
                      font-size: 25px;
                    ">
                            <ion-icon name="hourglass-outline"></ion-icon>
                          </td>
                          <td class="hide-on-mobile" style="text-align: center" colspan="5"></td>
                        </ng-container>
                      </ng-container>

                      <ng-container
                        *ngIf="(today.getMonth() + 1 > selectedMonth && today.getFullYear() == selectedYear) || (today.getFullYear() > selectedYear && today.getMonth() + 1 <= selectedMonth)">
                        <!--AZ ELŐZŐ HÓNAPOK HÓNAP-->
                        <ng-container *ngIf="!day.isWeekend && !day.isHoliday">
                          <!--NEM HÉTVÉGE-->
                          <ng-container *ngIf="day.nyilvantartas">
                            <!--LÉTEZIK NYILVÁNTARTÁS-->
                            <td *ngIf="day.nyilvantartas.status == 1 && isNapTeljes(day.nyilvantartas, day.dayDate)" style="
                        background-color: var(--ion-color-success-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      " [title]="napGyorsEllenorzesUzenet(day.nyilvantartas, day.dayDate)">
                              <ion-icon name="checkmark-outline"></ion-icon>
                            </td>
                            <td *ngIf="isKitoltetlenJelenlet(day.nyilvantartas) || isNapReszleges(day.nyilvantartas, day.dayDate)" style="
                        background-color: #f59e0b;
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      " [title]="napGyorsEllenorzesUzenet(day.nyilvantartas, day.dayDate)">
                              <ion-icon name="alert-circle-outline"></ion-icon>
                            </td>

                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 1" style="text-align: center">
                              {{ day.nyilvantartas.start | date : "HH:mm" : "GMT" }}
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 1" style="text-align: center">
                              {{ day.nyilvantartas.end | date : "HH:mm" : "GMT" }}
                            </td>

                            <!-- ÓRASZÁM és KÖNYVELT ÓRÁK – mint az aktuális hónapnál: az órarendből. Itt eddig
                                 a régi, soha ki nem töltött pipa-mező (c1/c2) állt, ezért a korábbi hónapokban
                                 mindig ugyanaz az ikon látszott, bárkit választott ki az admin. -->
                            <td *ngIf="day.nyilvantartas.status == 1" style="text-align: center; font-weight: 600">
                              {{ napiOra(day).relevans }}
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 1" style="text-align: center; font-weight: 600"
                                [style.color]="napiOra(day).relevans === 0 ? '' : (napiOra(day).naplozott >= napiOra(day).relevans ? 'var(--ion-color-success-shade)' : 'var(--ion-color-warning-shade)')"
                                [title]="napiOra(day).naplozott < napiOra(day).relevans ? 'Még ' + (napiOra(day).relevans - napiOra(day).naplozott) + ' óra könyveletlen' : ''">
                              {{ napiOra(day).naplozott }}
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 1" style="text-align: center">
                              {{ getNapiHelyettesitesOsszesites(day).eseti }} /
                              {{ getNapiHelyettesitesOsszesites(day).tartos }} /
                              {{ getNapiHelyettesitesOsszesites(day).kotottTulora }}
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 2" style="
                        background-color: var(--ion-color-tertiary-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">

                              <ion-icon name="bed-outline"></ion-icon>
                            </td>

                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 2" style="
                        background-color: var(--ion-color-tertiary-shade);
                        text-align: center;
                        color: white;
                      " colspan="5">
                              Fizetett szabadság
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 3" style="
                        background-color: var(--ion-color-warning-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">
                              <ion-icon name="medkit-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 3" style="
                        background-color: var(--ion-color-warning-shade);
                        text-align: center;
                        color: white;
                      " colspan="5">
                              Betegszabadság / táppénz
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 7" style="
                        background-color: var(--ion-color-secondary-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">
                              <ion-icon name="globe-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 7" style="
                        background-color: var(--ion-color-secondary-shade);
                        text-align: center;
                        color: white;
                      " colspan="5">
                              Digitális távoktatás / Home Office
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 4" style="
                        background-color: var(--ion-color-secondary-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">
                              <ion-icon name="car-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 4" style="
                        background-color: var(--ion-color-secondary-shade);
                        text-align: center;
                        color: white;
                      " colspan="5">
                              Iskolai kiküldetés
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 5" style="
                        background-color: var(--ion-color-light-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">
                              <ion-icon name="ban-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 5" style="
                        background-color: var(--ion-color-light-shade);
                        text-align: center;
                        color: white;
                      " colspan="5">
                              Fizetés nélküli szabadság
                            </td>
                            <td *ngIf="day.nyilvantartas.status == 6" style="
                        background-color: var(--ion-color-success-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">
                              <ion-icon name="leaf-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" *ngIf="day.nyilvantartas.status == 6" style="
                        background-color: var(--ion-color-success-shade);
                        text-align: center;
                        color: white;
                      " colspan="5">
                              Nincs tanítási órám
                            </td>
                          </ng-container>
                          <ng-container *ngIf="!day.nyilvantartas">
                            <!--NINCS NYILVÁNTARTÁS-->
                            <td style="
                        background-color: var(--ion-color-danger-shade);
                        text-align: center;
                        font-size: 25px;
                        padding: 0;
                        color: white;
                      ">
                              <ion-icon name="alert-circle-outline"></ion-icon>
                            </td>
                            <td class="hide-on-mobile" style="text-align: center" colspan="5">
                              Nincs adat
                            </td>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="day.isWeekend || day.isHoliday">
                          <!--HÉTVÉGE-->
                          <td style="
                      background-color: var(--ion-color-light);
                      text-align: center;
                      font-size: 25px;
                    ">
                            <ion-icon name="close-circle-outline"></ion-icon>
                          </td>
                          <td class="hide-on-mobile" style="text-align: center" colspan="5">
                            Munkaszüneti nap
                          </td>
                        </ng-container>
                      </ng-container>

                      <ng-container
                        *ngIf="(today.getMonth() + 1 < selectedMonth && today.getFullYear() == selectedYear) || (today.getFullYear() < selectedYear && today.getMonth() + 1 >= selectedMonth)">
                        <!--A KÖVETKEZŐ HÓNAP-->
                        <ng-container *ngIf="!day.nyilvantartas">
                          <!--NINCS NYILVÁNTARTÁS-->
                          <td style="
                      background-color: var(--ion-color-light);
                      text-align: center;
                      font-size: 25px;
                    ">
                            <ion-icon name="hourglass-outline"></ion-icon>
                          </td>
                          <td class="hide-on-mobile" style="text-align: center" colspan="5"></td>
                        </ng-container>
                        <ng-container *ngIf="day.nyilvantartas">
                          <!--LÉTEZIK NYILVÁNTARTÁS (előre rögzített jogcím)-->
                          <td style="text-align: center; font-size: 25px; padding: 0; color: white;"
                            [style.background]="'var(--ion-color-' + statuszok[day.nyilvantartas.status][1] + '-shade)'">
                            <ion-icon [name]="statuszok[day.nyilvantartas.status][0]"></ion-icon>
                          </td>
                          <td class="hide-on-mobile" colspan="5"
                            style="text-align: center; color: white;"
                            [style.background]="'var(--ion-color-' + statuszok[day.nyilvantartas.status][1] + '-shade)'">
                            {{ statuszok[day.nyilvantartas.status][2] }}
                          </td>
                        </ng-container>
                      </ng-container>

                      <!--ng-container *ngIf="
                      userMetadata &&
                      (userMetadata.munkakor == 'igazgató' ||
                        userMetadata.munkakor == 'igazgatóhelyettes' ||
                        userMetadata.munkakor == 'kancellár' ||
                        userMetadata.munkakor == 'munkaügyi csoportvezető' ||
                        userMetadata.munkakor == 'admin')
                    "-->
                      <td style="text-align: center; font-size: 25px; padding: 0"
                        *ngIf="!day.isWeekend && !day.isHoliday">
                        <ion-button color="secondary" (click)="initModal(day, 0, true)"
                          *ngIf="jovobeliNap(day)">
                          <ion-icon slot="icon-only" name="bed"></ion-icon>
                        </ion-button>
                        <ion-button color="primary" (click)="initModal(day)"
                          *ngIf="!jovobeliNap(day)">
                          <ion-icon slot="icon-only" name="create"></ion-icon>
                        </ion-button>
                        <ion-button color="danger" [disabled]="!day.nyilvantartas" (click)="initModal(day, 1)">
                          <ion-icon slot="icon-only" name="trash"></ion-icon>
                        </ion-button>
                      </td>
                      <td style="text-align: center; font-size: 25px; padding: 0"
                        *ngIf="day.isWeekend || day.isHoliday">
                        <ion-icon name="close-circle-outline"></ion-icon>
                      </td>
                      <!--/ng-container-->
                      <!--ng-container *ngIf="!(
                      userMetadata &&
                      (userMetadata.munkakor == 'igazgató' ||
                        userMetadata.munkakor == 'igazgatóhelyettes' ||
                        userMetadata.munkakor == 'kancellár' ||
                        userMetadata.munkakor == 'munkaügyi csoportvezető' ||
                        userMetadata.munkakor == 'admin'))
                    ">
                        <td style="text-align: center; font-size: 25px; padding: 0" *ngIf="
                  ((getWeekNumber(day.dayDate)[1] == getWeekNumber(today)[1] &&
                    getWeekNumber(day.dayDate)[0] == getWeekNumber(today)[0]) ||
                    (getWeekNumber(day.dayDate)[1]+nyitotthet >=
                      getWeekNumber(today)[1]  &&
                      getWeekNumber(day.dayDate)[0] ==
                        getWeekNumber(today)[0]) || (getWeekNumber(today)[1] == 1 && getWeekNumber(day.dayDate)[0] < getWeekNumber(today)[0] && getWeekNumber(day.dayDate)[1] == weeksInYear(selectedYear))
                        || getWeekNumber(day.dayDate)[1]+nyitotthet > weeksInYear(selectedYear) && weeksInYear(selectedYear)-getWeekNumber(today)[1]<=getWeekNumber(day.dayDate)[1]) &&
                  !day.isWeekend && !day.isHoliday &&
                  ((today.getMonth() + 1 == selectedMonth && today.getDate() + 1 > day.dayNumber) ||
                  (today.getMonth() == selectedMonth) || (today.getMonth()+1<selectedMonth && today.getFullYear()>selectedYear))
                ">
                          <ion-button color="primary" (click)="initModal(day)">
                            <ion-icon slot="icon-only" name="create"></ion-icon>
                          </ion-button>
                          <ion-button color="danger" [disabled]="!day.nyilvantartas" (click)="initModal(day, 1)">
                            <ion-icon slot="icon-only" name="trash"></ion-icon>
                          </ion-button>
                        </td>
                        <td style="text-align: center; font-size: 25px; padding: 0" *ngIf="
                  !(
                    ((getWeekNumber(day.dayDate)[1] == getWeekNumber(today)[1] &&
                    getWeekNumber(day.dayDate)[0] == getWeekNumber(today)[0]) ||
                    (getWeekNumber(day.dayDate)[1]+nyitotthet >=
                      getWeekNumber(today)[1]  &&
                      getWeekNumber(day.dayDate)[0] ==
                        getWeekNumber(today)[0]) || (getWeekNumber(today)[1] == 1 && getWeekNumber(day.dayDate)[0] < getWeekNumber(today)[0] && getWeekNumber(day.dayDate)[1] == weeksInYear(selectedYear))
                        || getWeekNumber(day.dayDate)[1]+nyitotthet > weeksInYear(selectedYear) && weeksInYear(selectedYear)-getWeekNumber(today)[1]<=getWeekNumber(day.dayDate)[1]) &&
                  !day.isWeekend && !day.isHoliday &&
                  ((today.getMonth() + 1 == selectedMonth && today.getDate() + 1 > day.dayNumber) ||
                  (today.getMonth() == selectedMonth) || (today.getMonth()+1<selectedMonth && today.getFullYear()>selectedYear))
                  )
                ">
                          <ion-icon name="close-circle-outline"></ion-icon>
                        </td>
                      </ng-container-->



                      <td style="text-align: center" *ngIf="day.nyilvantartas">
                        {{
                        diffDateHours(day.nyilvantartas.start, day.nyilvantartas.end)
                        }}
                        óra
                      </td>
                      <td style="text-align: center" *ngIf="!day.nyilvantartas">-</td>

                      <!--td
              *ngIf="
                day.nyilvantartas &&
                day.nyilvantartas.status == 1 &&
                day.nyilvantartas.c3 != 1
              "
              style="text-align: center; font-size: 25px; padding: 0"
            >
              <ion-icon name="alert-circle-outline"></ion-icon>
            </td>
            <td
              *ngIf="
                day.nyilvantartas &&
                day.nyilvantartas.status == 1 &&
                day.nyilvantartas.c3 == 1
              "
              style="text-align: center; font-size: 25px; padding: 0"
            >
              <ion-icon name="checkmark-circle-outline"></ion-icon>
            </td-->
                    </tr>
                    <tr *ngIf="isWeekBoundary(idx)">
                      <td colspan="9">
                        {{ isPartialWeek(day.week) ? 'Heti összesített részóraszám' : 'Heti összesített óraszám' }}:
                        {{ getWeekSumByWeek(day.week) }} óra
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-modal (willDismiss)="onWillDismiss($event)" [class]="tomeges ? '' : 'nagy'">
    <ng-template>
      <ng-container *ngIf="tomeges">
        <ion-header>
          <ion-toolbar color="primary">
            <ion-buttons slot="start">
              <ion-button (click)="cancel()">Mégse</ion-button>
            </ion-buttons>
            <ion-title>Tömeges rögzítés (BÉTA)</ion-title>
            <ion-buttons slot="end">
              <ion-button style="background: white;border-radius: 5px;" (click)="tomegesRekord()" [strong]="true"
                [disabled]="validateForm()" shape="round" color="primary">Mentés</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-grid *ngIf="submittype == '0'">
            <ion-row>
              <ion-col>
                <ion-item *ngIf="jelenlet">
                  <label>Jelenlét*</label>

                  <select name="jelenlet" [(ngModel)]="jelenlet" style="position: absolute; right: 15px">
                    <!--option value="1">Dolgozik</option-->
                    <option value="2">Fizetett szabadság</option>
                    <option value="3">Betegszabadság / táppénz</option>
                    <!--option value="7">Digitális távoktatás</option>
                  <option value="4">Iskolai kiküldetés</option-->
                    <option value="5">Fizetés nélküli szabadság</option>
                    <option value="6">Nincs tanítási órám</option>
                  </select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="holidays">
              <ion-col>
                <label>Kezdő dátum*</label>
                <ion-datetime (click)="datepicker.reset(vegsodatum)" (ionChange)="KezdoDatumChanged($event)"
                  presentation="date" [isDateEnabled]="isWeekday" [firstDayOfWeek]="1"
                  [(ngModel)]="kezdodatum"></ion-datetime>
              </ion-col>
              <ion-col>
                <label>Végső dátum*</label>
                <ion-datetime #datepicker [disabled]="!kezdodatum" presentation="date" [isDateEnabled]="isKezdoKisebb"
                  [firstDayOfWeek]="1" [(ngModel)]="vegsodatum"></ion-datetime>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col style="text-align: center;" *ngIf="jelenlet && kezdodatum && vegsodatum">
                {{jelenletText[jelenlet]}} {{kezdodatum | date:'yyyy. MM. dd.'}} - {{vegsodatum | date:'yyyy. MM. dd.'}}
                között.
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-content>

      </ng-container>

      <ng-container *ngIf="!tomeges">
        <ion-header>
          <ion-toolbar color="primary">
            <ion-buttons slot="start">
              <ion-button (click)="cancel()">Mégse</ion-button>
            </ion-buttons>
            <ion-title>Napló ({{ selectedMonth }}-{{ selectedDay }})</ion-title>
            <ion-buttons slot="end">
              <ion-button *ngIf="jelenlet" style="background: white;border-radius: 5px;" (click)="confirm()"
                [strong]="true" [disabled]="validateForm() && false" shape="round" color="primary">Mentés</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <!--ion-segment [value]="submittype || 0">
          <ion-segment-button value="0" (click)="setSubmitType('0')">
            <ion-label>Egyszerű</ion-label>
          </ion-segment-button>
          <ion-segment-button value="1" (click)="setSubmitType('1')">
            <ion-label>Osztott</ion-label>
          </ion-segment-button>
        </ion-segment-->

          <ion-grid *ngIf="submittype == '0'">
            <h2>Jelenléti adatok</h2>
            <ion-row>
              <ion-col>
                <ion-item *ngIf="jelenlet">
                  <label>Jelenlét*</label>

                  <select name="jelenlet" [(ngModel)]="jelenlet" style="position: absolute; right: 15px">
                    <option value="1" [hidden]="elore">Dolgozik</option>
                    <option value="2">Fizetett szabadság</option>
                    <option value="3">Betegszabadság / táppénz</option>
                    <option value="7" [hidden]="elore">Digitális távoktatás / Home Office</option>
                    <option value="4" [hidden]="elore">Iskolai kiküldetés</option>
                    <option value="5">Fizetés nélküli szabadság</option>
                    <option value="6">Nincs tanítási órám / Egyéb mentesülés</option>
                    <option value="8">Egyéb munkaviszony szünetelés</option>
                  </select>
                  <!--ion-select label="Jelenlét*" cancelText="Mégse">
                  <ion-select-option value="1" selected
                    >Dolgozik</ion-select-option
                  >
                  <ion-select-option value="2">Szabadság</ion-select-option>
                  <ion-select-option value="3">Betegség</ion-select-option>
                </ion-select-->
                  <!--ion-radio-group
                  [(ngModel)]="jelenlet"
                  [allowEmptySelection]="false"
                >
                  <ion-radio value="1">Dolgozik</ion-radio>
                  <ion-radio value="2">Szabadság</ion-radio>
                  <ion-radio value="3">Betegség</ion-radio>
                </ion-radio-group-->
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="jelenlet == 1 || jelenlet == 7 || jelenlet == 4">
              <ion-col>
                <ion-item>
                  <ion-label position="stacked">Érkezés (óra)*</ion-label>
                  <ion-input type="number" placeholder="óra" [(ngModel)]="erko" min="6" max="21"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col>
                <ion-item>
                  <ion-label position="stacked">Érkezés (perc)*</ion-label>
                  <ion-input type="number" placeholder="perc" [(ngModel)]="erkp" min="0" max="59"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col>
                <ion-item>
                  <ion-label position="stacked">Távozás (óra)*</ion-label>
                  <ion-input type="number" placeholder="óra" [(ngModel)]="tavo" min="6" max="21"></ion-input>
                </ion-item>
              </ion-col>
              <ion-col>
                <ion-item>
                  <ion-label position="stacked">Távozás (perc)*</ion-label>
                  <ion-input type="number" placeholder="perc" [(ngModel)]="tavp" min="0" max="59"></ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
            <!--ion-row *ngIf="jelenlet == 1 || jelenlet == 7 || jelenlet == 4">
              <ion-col>
                <ion-item>
                  <ion-checkbox [(ngModel)]="c1">
                    Kötött munkaidő oktatással lekötött része (kötelező óraszám)
                  </ion-checkbox>
                </ion-item>
              </ion-col>
              <ion-col>
                <ion-item>
                  <ion-checkbox [(ngModel)]="c2">Igazgató által beosztott órák (32 óráig)</ion-checkbox>
                </ion-item>
              </ion-col>
            </ion-row-->
            <ion-row *ngIf="jelenlet == 1 || jelenlet == 7 || jelenlet == 4">
              <ion-col>
                <ion-item>
                  <ion-label position="stacked">Helyettesítés</ion-label>
                  <ion-input disabled type="number" placeholder="0" [(ngModel)]="helyettes" min="0"
                    max="59"></ion-input>
                </ion-item>
              </ion-col><ion-col>
                <ion-item>
                  <ion-label position="stacked">Ebből tartós</ion-label>
                  <ion-input disabled type="number" placeholder="0" [(ngModel)]="tartoshely" min="0"
                    max="59"></ion-input>
                </ion-item>
              </ion-col><ion-col>
                <ion-item>
                  <ion-label position="stacked">Ebből szívességi</ion-label>
                  <ion-input disabled type="number" placeholder="0" [(ngModel)]="szivhely" min="0" max="59"></ion-input>
                </ion-item>
              </ion-col>
            </ion-row>

            <!-- Utólagos helyettesítés bejelentése – ugyanaz a folyamat, mint a
                 „Helyettesítés bejelentése" képernyőn, csak nem kell átmenni oda.
                 A JÓVÁHAGYÁS szándékosan NEM került ide: az az adminisztrátoré. -->
            <ion-row *ngIf="helyBe && !elore && !helyJovobeli() && (jelenlet == 1 || jelenlet == 7 || jelenlet == 4)">
              <ion-col>
                <ion-button *ngIf="!helyNyitva" size="small" fill="outline" color="primary"
                  (click)="helyMegnyit()">
                  <ion-icon slot="start" name="swap-horizontal-outline"></ion-icon>
                  Helyettesített óra bejelentése
                </ion-button>

                <ion-card *ngIf="helyNyitva" color="light">
                  <ion-card-header>
                    <ion-card-title style="font-size:16px">
                      Helyettesített óra bejelentése – {{ helyNap() }}
                    </ion-card-title>
                    <ion-note color="medium">
                      A saját óráid és a jövőbeli órák nem jelennek meg. A bejelentés
                      <b>nem</b> írja át az órarendet: az adminisztrátor hagyja jóvá.
                    </ion-note>
                  </ion-card-header>
                  <ion-card-content>
                    <!--  Hányadik óra: nem kötelező szűrő. Egy napon húsz-harminc óra is
                          lehet a listában – ha tudod, melyiket tartottad, itt szűkítheted.  -->
                    <div class="hely-szuro">
                      <ion-input label="Hányadik óra (nem kötelező)" label-placement="stacked"
                                 fill="outline" type="number" min="1" max="12" inputmode="numeric"
                                 placeholder="mind" [(ngModel)]="helyOraSzam"
                                 (ionChange)="helyOrakBetolt()"></ion-input>
                      <ion-select *ngIf="helyOrak?.length" label="Tanár (kinek az órája)" label-placement="stacked"
                                  fill="outline" interface="popover" [(ngModel)]="helyTanarSzuro">
                        <ion-select-option value="">mind</ion-select-option>
                        <ion-select-option *ngFor="let t of helyTanarok" [value]="t">{{ t }}</ion-select-option>
                      </ion-select>
                    </div>
                    <div *ngIf="helyFut">Órák betöltése…</div>
                    <div *ngIf="!helyFut && helyOrak && helyOrak.length == 0">
                      Ezen a napon nincs bejelenthető óra.
                    </div>

                    <ion-list *ngIf="!helyFut && helyOrak && helyOrak.length" lines="full">
                      <ion-item *ngFor="let o of helySzurtOrak" button="true"
                        [disabled]="helyMarBejelentve(o)"
                        [color]="helyValasztott?.id === o.id ? 'primary' : ''"
                        (click)="helyValaszt(o)">
                        <ion-label>
                          <h3>{{ helyOraCim(o) }}</h3>
                          <p>
                            Órarend szerint: {{ o.tanar_nev || o.tanar }}
                            <span *ngIf="o.helyettesito_nev"> · rögzített helyettesítő: {{ o.helyettesito_nev }}</span>
                            <span *ngIf="helyMarBejelentve(o)"> · már bejelentve ({{ o.bejelentes_bejelento }})</span>
                          </p>
                        </ion-label>
                      </ion-item>
                    </ion-list>

                    <ion-row *ngIf="helyValasztott">
                      <ion-col size="12" size-md="4">
                        <ion-item>
                          <ion-label position="stacked">Típus</ion-label>
                          <select [(ngModel)]="helyTipus" [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let t of HELY_TIPUSOK" [value]="t.e">{{ t.n }}</option>
                          </select>
                        </ion-item>
                      </ion-col>
                      <ion-col size="12" size-md="4">
                        <ion-item>
                          <ion-label position="stacked">Mód</ion-label>
                          <select [(ngModel)]="helyMod" [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let m of HELY_MODOK" [value]="m.e">{{ m.n }}</option>
                          </select>
                        </ion-item>
                      </ion-col>
                      <ion-col size="12" size-md="4">
                        <ion-item>
                          <ion-label position="stacked">Indok (nem kötelező)</ion-label>
                          <ion-input [(ngModel)]="helyIndok" [ngModelOptions]="{standalone: true}"></ion-input>
                        </ion-item>
                      </ion-col>
                    </ion-row>

                    <ion-button size="small" color="primary" [disabled]="!helyValasztott || helyKuld"
                      (click)="helyBejelent()">Bejelentés</ion-button>
                    <ion-button size="small" fill="clear" color="dark" (click)="helyBezar()">Bezár</ion-button>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>

            <h2 [hidden]="elore">Tanórák / Foglalkozások
              <span *ngIf="napiOrarend?.length && konyveltSzamlalo.osszes" class="konyvelt-szamlalo"
                [class.kesz]="konyveltSzamlalo.konyvelt === konyveltSzamlalo.osszes"
                title="A témával lekönyvelt órák száma a nap saját óráiból">
                könyvelve: {{ konyveltSzamlalo.konyvelt }} / {{ konyveltSzamlalo.osszes }}
              </span></h2>
            <!-- Lezárt naplóidőszak (naplo-zaras.js): a kiszolgáló a módosítást elutasítja. -->
            <ion-row *ngIf="!elore && napLezart">
              <ion-col>
                <ion-card color="warning">
                  <ion-card-header>
                    <ion-card-subtitle><ion-icon name="lock-closed-outline"></ion-icon>
                      Ez a nap lezárt naplóidőszakba esik ({{ napLezart }}). Az órák nem módosíthatók –
                      ha javítani kell, az adminisztrátor feloldhatja (Admin › Intézmény › Naplózárás).</ion-card-subtitle>
                  </ion-card-header>
                </ion-card>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="!elore && napiOrarend && napiOrarend.length == 0">
              <ion-col>
                <ion-card color="primary">
                  <ion-card-header>
                    <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Nincs tanóra /
                      foglalkozás!</ion-card-title>
                  </ion-card-header>
                </ion-card>
              </ion-col>
            </ion-row>
            <ion-row *ngIf="jelenlet == 1 || jelenlet == 7 || jelenlet == 4">
              <ion-col>
                <ion-accordion-group [multiple]="true" color="primary" (ionChange)="oraMegnyitva($event)">
                  <ion-accordion [value]="o.id"
                    [class]="o.elmaradt == 1 ? 'tanora-szurke' : (o.helyettesites ? (o.tanar == uuid ? 'tanora-szurke' : (oraZold(o) ? 'tanora-zold' : 'tanora-lila')) : (oraZold(o) ? 'tanora-zold' : 'tanora-piros'))"
                    *ngFor="let o of napiOrarend; let i = index">
                    <ion-item slot="header"
                      [color]="o.elmaradt == 1 ? 'medium' : (o.helyettesites ? (o.tanar == uuid ? 'medium' : (oraZold(o) ? 'lime' : 'lila')) : (oraZold(o) ? 'lime' : 'rose'))">
                      <ion-label><span style="float:left;margin:8px">{{o.ora}} {{o.hossz > 1 ? " - "+(o.ora+o.hossz-1) :
                          ""}}. óra - {{ o.osztaly || o.csoport_nev }}
                          {{o.tantargy}}
                          <!-- Egyéb foglalkozás (szakkör, napközi, tanulószoba…): az egyéb foglalkozási naplóba
                               kerül (20/2012. EMMI r. 103. §) – a csoport típusa, backend/csoport-nevsor.js. -->
                          <span class="fogl-cimke" *ngIf="o.foglalkozas_tipus && o.foglalkozas_tipus !== 'tanorai'"
                                title="Egyéb foglalkozás – az egyéb foglalkozási naplóba kerül">{{ o.foglalkozas_nev }}</span>
                          <!--  A TEREM a helyettesítésnél a legfontosabb adat: a helyettesítő
                                nem a saját órarendjét járja, neki azt kell tudnia, hová menjen. -->
                          <span *ngIf="o.helyettesites">({{o.helyettesites_tipus}}:
                            {{o.tanar == uuid ? o.helyettesito : o.tarto}}<span *ngIf="o.terem">, {{o.terem}}</span>)</span>
                          <span *ngIf="!o.helyettesites && o.terem"> · {{o.terem}}</span>
                          <!-- Elmaradt óra: önálló állapot (nem helyettesítés), az okával. -->
                          <b *ngIf="o.elmaradt == 1"> · ELMARADT<span *ngIf="o.elmaradt_ok"> ({{o.elmaradt_ok}})</span></b>
                          <!-- Tantermen kívüli, digitális munkarend (digitalis-munkarend.js) – csak jelölés. -->
                          <span *ngIf="dmOra(o)" class="dm-jel" title="Az igazgató digitális munkarendet rendelt el erre az időszakra (Nkt. 27. § (2a)) – nyisd le az órát: add meg az online óra linkjét / adj ki beadandót">digitális munkarend</span></span>
                        <span style="float:right">
                          <ion-button [disabled]="!oraZold(o)" (click)="ertekeles($event,o)" size="small" color="primary">Értékelés</ion-button>
                          <!-- Elmaradt óra: a saját, be nem írt, nem helyettesített óra (pl. táppénz) – így nem
                               számít könyveletlennek. Önálló állapot (orarendv2.elmaradt), naplózva; a „Mégis
                               megtartva” vonja vissza. Lezárt napon egyik sem látszik (a kiszolgáló úgyis tiltaná). -->
                          <ion-button *ngIf="o.tanar == uuid && !o.helyettesites && !o.rogzitett_tema && !o.konyvelte && !o.hianyzo?.length && o.elmaradt != 1 && !napLezart"
                                      (click)="oraElmaradt($event, o)" size="small" color="medium" fill="outline">Elmaradt</ion-button>
                          <ion-button *ngIf="o.tanar == uuid && o.elmaradt == 1 && !napLezart"
                                      (click)="oraElmaradtVissza($event, o)" size="small" color="medium" fill="outline">Mégis megtartva</ion-button>
                          <!-- Az óra naplója: ki írta be, ki javította, mit mire (ora-naplo.js). -->
                          <ion-button (click)="elozmenyek($event, o)" size="small" color="dark" fill="clear"
                                      title="Az óra beírásai és javításai">Előzmények</ion-button>
                          <!--ion-button (click)="ertekeles($event,o)" size="small" color="primary">Feljegyzés</ion-button-->
                        </span>
                      </ion-label>
                    </ion-item>
                    <div class="ion-padding" slot="content">
                      <!-- DIGITÁLIS MUNKAREND (Nkt. 27. § (2a)): az óra tetején, kiemelt felhívással – a tanár
                           közvetlenül itt adja meg az online óra linkjét, és innen ad ki beadandót (app-ora-online,
                           backend/beadando.js › ora_online). Ilyenkor a lap alján lévő blokk nem jelenik meg. -->
                      <ion-row *ngIf="dmOra(o) as dm">
                        <ion-col>
                          <app-ora-online *ngIf="o.id" [ora]="o" [digitalis]="dm"></app-ora-online>
                          <ion-note class="dm-megj" *ngIf="!o.id">
                            <b>Digitális munkarend</b> ({{ dm.tol }}{{ dm.ig !== dm.tol ? ' – ' + dm.ig : '' }}<span *ngIf="dm.ok">, {{ dm.ok }}</span>):
                            az óra online, személyes találkozás nélkül folyik. A jelenlét itt az online részvétel – aki nem
                            vett részt, azt a szokásos módon jelöld hiányzónak.
                          </ion-note>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="o.hossz > 1">
                        <ion-col>
                          <ion-item>
                            <ion-checkbox justify="space-between" [(ngModel)]="o.temabontas">Óra témájának
                              megbontása</ion-checkbox>
                          </ion-item>
                        </ion-col>
                        <ion-col>
                          Sorszám: {{o.count_until_cutoff}}<br>
                          Előző óra témája:
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="o.hossz == 1 || !o.temabontas">
                        <ion-col>
                          <ion-item>
                            <ion-label position="stacked">Téma*</ion-label>
                            <ion-input [(ngModel)]="o.tema" (ngModelChange)="temaValtozott(o, $event)" [disabled]="(o.tanar == uuid && o.helyettesites) || o.elmaradt == 1 || !!napLezart"></ion-input>
                          </ion-item>
                        </ion-col>
                        <ion-col>
                          Sorszám: {{o.count_until_cutoff}}<br>
                          Előző óra témája: TBA
                        </ion-col>
                      </ion-row>
                      <ng-container *ngIf="o.hossz > 1 && o.temabontas">
                        <ion-row *ngFor="let item of [].constructor(o.hossz); let index = index">
                          <ion-col>
                            <ion-item>
                              <ion-label position="stacked">{{index+1}}. óra témája</ion-label>
                              <ion-input [(ngModel)]="o.tema" (ngModelChange)="temaValtozott(o, $event)"
                                [disabled]="o.tanar == uuid && o.helyettesites"></ion-input>
                            </ion-item>
                          </ion-col>
                          <ion-col>
                            Sorszám: {{o.count_until_cutoff}}<br>
                            Előző óra témája:
                          </ion-col>
                        </ion-row>
                      </ng-container>
                      <!-- TÉMA NÉLKÜL NEM KÖNYVELŐDIK. Ahol a tanmenet nem kínál témát (pl. tanmenet
                           nélküli csoport), a mező üresen áll – eddig semmi nem mondta, hogy így az
                           óra mentés után is piros marad, és a KRÉTÁ-ba sem kerül át. -->
                      <ion-row *ngIf="temaHianyzik(o)">
                        <ion-col>
                          <ion-note color="danger">
                            <ion-icon name="alert-circle-outline"></ion-icon>
                            Téma nélkül az óra nem könyvelődik le (és a KRÉTÁ-ba sem kerül át) — írd be a témát.
                          </ion-note>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="o.osztaly_nevsor">
                        <ion-col>
                          <ion-item>
                            <ion-label position="stacked">Házi feladat</ion-label>
                            <ion-input [(ngModel)]="o.hazifeladat"
                              [disabled]="o.tanar == uuid && o.helyettesites"></ion-input>
                          </ion-item>
                        </ion-col>
                        <ion-col>
                          <ion-button (click)="hazifeladat($event,o)" color="primary">Melléklet csatolása</ion-button>
                        </ion-col>
                      </ion-row>
                      <!-- DIGITÁLIS MUNKAREND: online óra link + az órához kiadott beadandók (app-ora-online,
                           backend/beadando.js). Saját végpont, a napló Mentés gombjától független. Digitális
                           munkarendű napon az óra tetején, kiemelve jelenik meg (lásd fent), itt nem. -->
                      <ion-row *ngIf="o.id && !dmOra(o)">
                        <ion-col>
                          <app-ora-online [ora]="o"></app-ora-online>
                        </ion-col>
                      </ion-row>
                      <!--ion-row *ngIf="o.osztaly_nevsor">
                        <ion-col>
                          <ion-item>
                            <label>Számonkérés típusa</label>
                            <select name="jelenlet" [(ngModel)]="o.szam_tipus" style="position: absolute; right: 15px">
                              <option [value]="it.id" *ngFor="let it of ertekelesTipus">{{it.nev}}</option>
                            </select>
                          </ion-item>
                        </ion-col>
                        <ion-col>
                          <ion-item>
                            <ion-label position="stacked">Számonkérés témája</ion-label>
                            <ion-input [(ngModel)]="o.szam_tema"
                              [disabled]="o.tanar == uuid && o.helyettesites"></ion-input>
                          </ion-item>
                        </ion-col>
                      </ion-row-->
                      <ion-row *ngIf="o.osztaly_nevsor">
                        <ion-col class="nevsor-fej">
                          <h3>Névsor - {{o.osztaly_nevsor.length}} fő</h3>
                          <!-- KERESÉS A NÉVSORBAN (#1097): csak elrejti a többi sort, a jelölések megmaradnak. -->
                          <ion-input class="nevsor-kereso" fill="outline" type="search" placeholder="Tanuló keresése…"
                                     [clearInput]="true" [debounce]="150" *ngIf="o.osztaly_nevsor.length > 5"
                                     [(ngModel)]="o._nevSzuro" aria-label="Tanuló keresése a névsorban">
                            <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
                          </ion-input>
                          <ion-note color="medium" class="nevsor-sugo" *ngIf="o._nevSzuro?.trim()">
                            {{ nevsorTalalat(o._nevSzuro, o.osztaly_nevsor) }} találat
                          </ion-note>
                          <!-- CSOPORTOS ÓRA: a tanulók osztályonkénti megoszlása (102. § (3) b)). -->
                          <ion-note color="medium" class="nevsor-megoszlas" *ngIf="o.megoszlasSzoveg">
                            Osztályonként: {{ o.megoszlasSzoveg }}
                          </ion-note>
                          <!--  HIÁNYZÓK ÁTVÉTELE. Korábban a jelölés magától terjedt át a
                                kolléga többi órájára – csendben, és csak a SAJÁT óráira.
                                Most kérésre fut, és a nap ÖSSZES óráját nézi: a reggel,
                                más tanár által beírt hiányzót is behozza. Előbb megmutatja,
                                kit hol jelöltek be; a beírás külön döntés. -->
                          <ion-button size="small" fill="outline" *ngIf="!o.opcionalis"
                                      (click)="hianyzokAtvetele(o)" [disabled]="atvetelFut[o.id] || o.elmaradt == 1">
                            <ion-icon slot="start" name="people-outline"></ion-icon>
                            {{ atvetelFut[o.id] ? 'Keresés…' : 'Hiányzók átvétele' }}
                          </ion-button>
                          <ion-note color="medium" class="nevsor-sugo" *ngIf="!o.opcionalis">
                            a nap többi órájából, tanártól függetlenül
                          </ion-note>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="o.osztaly_nevsor" class="hide-on-mobile">
                        <ion-col>
                          <ion-list>
                            <ion-item *ngFor="let n of o.osztaly_nevsor; let j = index"
                              [class.nevsor-rejtett]="!nevsorEgyezik(o._nevSzuro, n)"
                              [class.felmentett-sor]="oralatogatasAlol(o, n)"
                              [title]="oralatogatasAlol(o, n) ? 'Az óra látogatása alól felmentve – nem írható be hiányzónak' : ''"
                              [color]="o.opcionalis ? (jelenvoltAllapot(o,n)==='jelen' ? 'success' : (jelenvoltAllapot(o,n)==='nem' ? 'danger' : '')) : (o.hianyzo.indexOf(n.oktazon) != -1 ? 'danger' : '')">
                              <!-- Több osztályt átfogó csoportos órán a tanuló osztálya (az óra napján, a jogviszony szerint). -->
                              <span slot="start" class="nevsor-osztaly" *ngIf="o.tobbOsztaly">{{ n.osztaly || '—' }}</span>
                              <!-- A tanuló neve mellett visszafogott jelzés: SNI, BTMN, és ha az ÓRA TANTÁRGYÁRA
                                   szóló felmentése van (KRÉTA-felmentés vagy felmentő határozat) – részletek a súgóban. -->
                              <ion-label style="flex: 1 !important"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="n.oktazon" [nev]="n.nev"></app-profilkep>{{n.nev}}<ng-container *ngIf="o.nevsor_jelzesek?.[n.oktazon] as j"><span class="nj-cimkek"><span class="nj nj-sni" *ngIf="j.sni" title="Sajátos nevelési igényű (SNI) tanuló">SNI</span><span class="nj nj-btmn" *ngIf="j.btmn" title="Beilleszkedési, tanulási, magatartási nehézséggel küzd (BTMN)">BTMN</span><span class="nj nj-em" *ngIf="j.egyeni_munkarend" [title]="j.felmentes_cim">egyéni munkarend</span><ion-icon class="nj-ikon nj-i-ora" *ngIf="j.oralatogatas_alol" name="walk-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-ert" *ngIf="j.ertekeles_alol" name="close-circle-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-szov" *ngIf="j.szovegesen" name="chatbox-ellipses-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-felm" *ngIf="j.felmentes?.length && !j.oralatogatas_alol && !j.ertekeles_alol && !j.szovegesen" name="document-text-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-kedv" *ngIf="j.kedvezmeny?.length" name="hourglass-outline" [title]="j.kedvezmeny_cim"></ion-icon></span></ng-container><ng-container *ngIf="mulasztasArany(o, n) as ma"><span class="nj nj-ma" [ngClass]="'nj-ma-' + ma.szint" [title]="mulasztasAranyCim(ma)">{{ ma.szazalek }}%</span></ng-container></ion-label>
                              <!-- Opcionális részvétel: üres alap, csak jelen volt / nem volt -->
                              <ng-container *ngIf="o.opcionalis">
                                <ion-button (click)="jelolJelenvolt(o, n)" slot="end" size="default"
                                  [color]="jelenvoltAllapot(o,n)==='jelen' ? 'success' : 'light'"> Jelen volt </ion-button>
                                <ion-button (click)="jelolNemvolt(o, n)" slot="end" size="default"
                                  [color]="jelenvoltAllapot(o,n)==='nem' ? 'danger' : 'light'"> Nem volt </ion-button>
                              </ng-container>
                              <!-- Normál tanórai jelenlét + tanórai gombok -->
                              <ng-container *ngIf="!o.opcionalis">
                              <ion-button (click)="jelolJelenlet(o, n)" slot="end"
                                size="default" [color]="o.hianyzo.indexOf(n.oktazon) == -1 ? 'primary' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) == -1"> Jelenlét </ion-button>
                              <!--  AKI AZ ÓRA LÁTOGATÁSA ALÓL FEL VAN MENTVE, AZ NEM HIÁNYZIK. A távolléte nem
                                    mulasztás, ezért a gomb tiltott – a „Jelenlét" viszont marad, hogy egy korábbi
                                    téves beírás javítható legyen. -->
                              <ion-button (click)="jelolHianyzo(o, n)" slot="end" size="default"
                                [color]="o.hianyzo.indexOf(n.oktazon) != -1 ? 'primary' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1 || oralatogatasAlol(o, n) || o.elmaradt == 1"
                                [title]="o.elmaradt == 1 ? 'Elmaradt órán nincs hiányzó – ha megtartottad, előbb „Mégis megtartva”' : ''"> Hiányzik </ion-button>
                              <!-- Késés percben. Aki hiányzik, az nem késett – ott a mező tiltott.
                                   45 összegyűlt igazolatlan perc a rendszerben 1 igazolatlan órát ad.

                                   SZÁNDÉKOSAN NEM `type="number"`. A számmező pörgetőnyilai a névsor
                                   szűk soraiban pont a kattintási felület mellett vannak, és egy
                                   félrekattintással elvitték a percet. Ráadásul a fókuszban lévő
                                   számmezőt az egérgörgő és a fel/le billentyű is átállítja – a
                                   névsorban görgetve ez észrevétlenül történik meg. Szöveges mezőként
                                   egyik sem tud elcsúszni; a számbillentyűzet mobilon az
                                   `inputmode`-ból jön, az érték ellenőrzése pedig úgyis a mentésnél van. -->
                              <ion-input slot="end" class="keses-mezo" type="text" inputmode="numeric"
                                maxlength="3" placeholder="késés"
                                [title]="kesesIgazolt(o, n) ? 'Igazolt késés' : 'Késés percben'"
                                [class.igazolt]="kesesIgazolt(o, n)"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1"
                                [value]="kesesPerc(o, n)"
                                (ionBlur)="kesesValt(o, n, $any($event.target).value)"></ion-input>
                              <ion-note slot="end" class="keses-egyseg">perc</ion-note>
                              <ion-button (click)="oraPerkChanger(o,n,'hazihiany')" slot="end" size="small"
                                title="Házifeladat hiány"
                                [color]="o.hazihiany.indexOf(n.oktazon) != -1 ? 'danger' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1"> <ion-icon slot="icon-only"
                                  name="home"></ion-icon> </ion-button>
                              <ion-button (click)="oraPerkChanger(o,n,'felszhiany')" slot="end" size="small"
                                title="Felszerelés hiány"
                                [color]="o.felszhiany.indexOf(n.oktazon) != -1 ? 'danger' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1"> <ion-icon slot="icon-only"
                                  name="library"></ion-icon> </ion-button>
                              <ion-button (click)="oraPerkChanger(o,n,'felmentes')" slot="end" size="small"
                                title="Felmentés" [color]="o.felmentes.indexOf(n.oktazon) != -1 ? 'warning' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1"> <ion-icon slot="icon-only"
                                  name="medkit"></ion-icon> </ion-button>
                              <ion-button (click)="oraPerkChanger(o,n,'dicseret')" slot="end" size="small"
                                title="Tanórai dicséret"
                                [color]="o.dicseret.indexOf(n.oktazon) != -1 ? 'success' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1"> <ion-icon slot="icon-only"
                                  name="ribbon"></ion-icon> </ion-button>
                              </ng-container>
                            </ion-item>
                          </ion-list>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="o.osztaly_nevsor" class="hide-on-desktop">
                        <ion-col>
                          <div *ngFor="let n of o.osztaly_nevsor; let j = index" [class.nevsor-rejtett]="!nevsorEgyezik(o._nevSzuro, n)">
                            <div [class.felmentett-sor]="oralatogatasAlol(o, n)"
                              [title]="oralatogatasAlol(o, n) ? 'Az óra látogatása alól felmentve – nem írható be hiányzónak' : ''"
                              [style.background]="o.opcionalis ? (jelenvoltAllapot(o,n)==='jelen' ? '#d1f5d3' : (jelenvoltAllapot(o,n)==='nem' ? 'red' : 'white')) : (o.hianyzo.indexOf(n.oktazon) != -1 ? 'red' : 'white')">
                              <ion-label style="flex: 1 !important"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="n.oktazon" [nev]="n.nev"></app-profilkep>{{n.nev}}<span class="nevsor-osztaly-sorban" *ngIf="o.tobbOsztaly && n.osztaly"> · {{ n.osztaly }}</span><ng-container *ngIf="o.nevsor_jelzesek?.[n.oktazon] as j"><span class="nj-cimkek"><span class="nj nj-sni" *ngIf="j.sni" title="Sajátos nevelési igényű (SNI) tanuló">SNI</span><span class="nj nj-btmn" *ngIf="j.btmn" title="Beilleszkedési, tanulási, magatartási nehézséggel küzd (BTMN)">BTMN</span><span class="nj nj-em" *ngIf="j.egyeni_munkarend" [title]="j.felmentes_cim">egyéni munkarend</span><ion-icon class="nj-ikon nj-i-ora" *ngIf="j.oralatogatas_alol" name="walk-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-ert" *ngIf="j.ertekeles_alol" name="close-circle-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-szov" *ngIf="j.szovegesen" name="chatbox-ellipses-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-felm" *ngIf="j.felmentes?.length && !j.oralatogatas_alol && !j.ertekeles_alol && !j.szovegesen" name="document-text-outline" [title]="j.felmentes_cim"></ion-icon><ion-icon class="nj-ikon nj-i-kedv" *ngIf="j.kedvezmeny?.length" name="hourglass-outline" [title]="j.kedvezmeny_cim"></ion-icon></span></ng-container><ng-container *ngIf="mulasztasArany(o, n) as ma"><span class="nj nj-ma" [ngClass]="'nj-ma-' + ma.szint" [title]="mulasztasAranyCim(ma)">{{ ma.szazalek }}%</span></ng-container></ion-label><br>
                              <ng-container *ngIf="o.opcionalis">
                                <ion-button (click)="jelolJelenvolt(o, n)" slot="end" size="small"
                                  [color]="jelenvoltAllapot(o,n)==='jelen' ? 'success' : 'light'"> Jelen volt </ion-button>
                                <ion-button (click)="jelolNemvolt(o, n)" slot="end" size="small"
                                  [color]="jelenvoltAllapot(o,n)==='nem' ? 'danger' : 'light'"> Nem volt </ion-button>
                              </ng-container>
                              <ng-container *ngIf="!o.opcionalis">
                              <ion-button (click)="jelolJelenlet(o, n)" slot="end"
                                size="small" [color]="o.hianyzo.indexOf(n.oktazon) == -1 ? 'primary' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) == -1"> Jelenlét </ion-button>
                              <ion-button (click)="jelolHianyzo(o, n)" slot="end" size="small"
                                [color]="o.hianyzo.indexOf(n.oktazon) != -1 ? 'primary' : 'light'"
                                [disabled]="o.hianyzo.indexOf(n.oktazon) != -1 || oralatogatasAlol(o, n) || o.elmaradt == 1"
                                [title]="o.elmaradt == 1 ? 'Elmaradt órán nincs hiányzó – ha megtartottad, előbb „Mégis megtartva”' : ''"> Hiányzik </ion-button>
                              </ng-container>
                            </div>
                            <hr style="border-bottom: 1px solid black">
                          </div>
                        </ion-col>
                      </ion-row>
                    </div>
                  </ion-accordion>
                </ion-accordion-group>
              </ion-col>
            </ion-row>
            <h2 [hidden]="elore">Fogadóóra</h2>
            <!-- A Fogadóóra menü (fogadoora.component) ide ágyazva: az új fogadóóra alapnapja ez a nap. -->
            <ion-row *ngIf="!elore">
              <ion-col>
                <app-fogadoora [beagyazott]="true" [nap]="modalNap"></app-fogadoora>
              </ion-col>
            </ion-row>
            <!--ion-row *ngIf="jelenlet == 1">
            <ion-col>
              <ion-item>
                <ion-checkbox [(ngModel)]="c3">Kötetlen munkaidő</ion-checkbox>
              </ion-item>
            </ion-col>
          </ion-row-->
          </ion-grid>
          <!--ion-grid *ngIf="submittype == '1'">
          <ion-row>
            <div class="scrollable-table printable">
              <table id="printable">
                <thead>
                <tr>
                  <th>Intézmény</th>
                  <th>Jelenlét</th>
                  <th>Érkezés</th>
                  <th>Távozás</th>
                  <th>#</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <select
                      name="jelenlet"
                      [(ngModel)]="jelenlet"
                    >
                      <option value="1">Dolgozik</option>
                      <option value="2">Fizetett szabadság</option>
                      <option value="3">Betegszabadság / táppénz</option>
                      <option value="7">Digitális távoktatás</option>
                      <option value="4">Iskolai kiküldetés</option>
                      <option value="5">Fizetés nélküli szabadság</option>
                      <option value="6">Nincs tanítási órám</option>
                    </select>
                  </td>
                  <td>
                    <select
                      name="jelenlet"
                      [(ngModel)]="jelenlet"
                    >
                      <option value="1">Dolgozik</option>
                      <option value="2">Fizetett szabadság</option>
                      <option value="3">Betegszabadság / táppénz</option>
                      <option value="7">Digitális távoktatás</option>
                      <option value="4">Iskolai kiküldetés</option>
                      <option value="5">Fizetés nélküli szabadság</option>
                      <option value="6">Nincs tanítási órám</option>
                    </select>
                  </td>
                  <td>
                    <ion-input
                      type="text"
                      placeholder="Érkezés (óó:pp)"
                      [(ngModel)]="erko"
                      min="6"
                      max="21"
                    ></ion-input>
                  </td>
                  <td>
                    <ion-input
                      type="text"
                      placeholder="Távozás (óó:pp)"
                      [(ngModel)]="tavo"
                      min="6"
                      max="21"
                    ></ion-input>
                  </td>
                  <td>
                    <ion-button color="danger">
                      <ion-icon slot="icon-only" name="trash"></ion-icon>
                    </ion-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </ion-row>
          <ion-row *ngIf="jelenlet == 1 || jelenlet == 7 || jelenlet == 4">
            <ion-col>
              <ion-item>
                <ion-checkbox [(ngModel)]="c1">
                  Kötött munkaidő oktatással lekötött része (kötelező óraszám)
                </ion-checkbox>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="jelenlet == 1 || jelenlet == 7 || jelenlet == 4">
            <ion-col>
              <ion-item>
                <ion-checkbox [(ngModel)]="c2"
                >Igazgató által beosztott órák (32 óráig)</ion-checkbox
                >
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid-->
        </ion-content>
      </ng-container>
    </ng-template>
  </ion-modal>

  <ion-modal [class]="'nagy'" #ertekelesmodal>
    <ng-template>
      <ng-container>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-title>Értékelés ({{ selectedMonth }}-{{ selectedDay }})</ion-title>
            <ion-buttons slot="end">
              <ion-button *ngIf="jelenlet" style="background: white;border-radius: 5px;"
                (click)="ertekelesmodal.dismiss()" [strong]="true" shape="round" color="primary">Bezár</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <!--ion-segment [value]="submittype || 0">
          <ion-segment-button value="0" (click)="setSubmitType('0')">
            <ion-label>Egyszerű</ion-label>
          </ion-segment-button>
          <ion-segment-button value="1" (click)="setSubmitType('1')">
            <ion-label>Osztott</ion-label>
          </ion-segment-button>
        </ion-segment-->

          <div class="ertk-lap">
            <!-- AZ ÓRA FEJLÉCE: tantárgy címként, az óra, az osztály/csoport, a terem és a
                 helyettesítés halk címkékként alatta. -->
            <div class="ertk-fejkartya">
              <div class="ertk-fej-ikon" aria-hidden="true"><ion-icon name="school-outline"></ion-icon></div>
              <div class="ertk-fej-szoveg">
                <h2 class="ertk-fej-cim">{{kivalasztottOra.tantargy}}</h2>
                <div class="ertk-chipek">
                  <span class="ertk-chip"><ion-icon name="time-outline" aria-hidden="true"></ion-icon>{{kivalasztottOra.ora}}{{kivalasztottOra.hossz > 1 ? "–" +
                    (kivalasztottOra.ora+kivalasztottOra.hossz-1) :""}}. óra</span>
                  <span class="ertk-chip"><ion-icon name="people-outline" aria-hidden="true"></ion-icon>{{kivalasztottOra.osztaly}}</span>
                  <span class="ertk-chip" *ngIf="kivalasztottOra.terem"><ion-icon name="location-outline" aria-hidden="true"></ion-icon>{{kivalasztottOra.terem}}</span>
                  <span class="ertk-chip ertk-chip-kiemelt" *ngIf="kivalasztottOra.helyettesites"><ion-icon name="swap-horizontal-outline" aria-hidden="true"></ion-icon>{{kivalasztottOra.helyettesites_tipus}}:
                    {{kivalasztottOra.tanar == uuid ? kivalasztottOra.helyettesito : kivalasztottOra.tarto}}</span>
                </div>
              </div>
            </div>

            <!-- A SZÁMONKÉRÉS ADATAI: egységes címkék, rugalmas rács (mobilon egymás alatt). -->
            <div class="ertk-urlap">
              <div class="ertk-mezo">
                <label class="ertk-cimke" for="ertk-szam-tipus">Számonkérés típusa<span class="ertk-kotelezo">*</span></label>
                <select id="ertk-szam-tipus" class="ertk-select" name="jelenlet" [(ngModel)]="kivalasztottOra.szam_tipus">
                  <option [value]="it.id" *ngFor="let it of valaszthatoTipusok(kivalasztottOra?.szam_tipus)">{{it.nev}}</option>
                </select>
              </div>
              <div class="ertk-mezo ertk-mezo-szeles">
                <label class="ertk-cimke">Téma</label>
                <ion-input class="ertk-input" type="text" placeholder="téma" [(ngModel)]="kivalasztottOra.szam_tema"></ion-input>
              </div>
              <div class="ertk-mezo">
                <label class="ertk-cimke" for="osztalyozasimod">Osztályozási mód<span class="ertk-kotelezo">*</span></label>
                <select id="osztalyozasimod" class="ertk-select" [(ngModel)]="kivalasztottOra.osztalyozasimod">
                  <option value="1">Osztályzat (1-5)</option>
                  <option value="2">Százalék</option>
                  <option value="4">Fokozat (Példás/Jó/Változó/Hanyag)</option>
                  <option value="3" disabled>Szöveg</option>
                </select>
              </div>
            </div>

            <div class="ertk-szakaszfej">
              <h3>Névsor</h3>
              <span class="ertk-letszam">{{kivalasztottOra.osztaly_nevsor.length}} fő</span>
              <!-- KERESÉS A NÉVSORBAN (#1097): csak elrejt – a jegyek index szerint mennek a tanulóhoz. -->
              <ion-input class="nevsor-kereso" fill="outline" type="search" placeholder="Tanuló keresése…"
                         [clearInput]="true" [debounce]="150" *ngIf="kivalasztottOra.osztaly_nevsor.length > 5"
                         [(ngModel)]="ertekelesNevSzuro" aria-label="Tanuló keresése a névsorban">
                <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
              </ion-input>
              <ion-note color="medium" *ngIf="ertekelesNevSzuro.trim()">
                {{ nevsorTalalat(ertekelesNevSzuro, kivalasztottOra.osztaly_nevsor) }} találat
              </ion-note>
            </div>
            <!-- TÖMEGES ÉRTÉKELÉS. Egy dolgozat után 25 tanulónak egyenként ugyanazt
                 beírni fölösleges kattintás; a típust a fenti választó adja, tehát ez
                 bármelyik értékelési típusnál működik. -->
            <div class="tomeges-sav" *ngIf="kivalasztottOra?.osztaly_nevsor?.length">
              <b>Tömeges kitöltés</b>
              <ng-container *ngIf="kivalasztottOra?.osztalyozasimod === '4' || isDualFokozatMode()">
                <span class="cimke" *ngIf="isDualFokozatMode()">Magatartás:</span>
                <ion-button *ngFor="let f of FOKOZAT_GOMBOK" size="small" fill="outline"
                            (click)="tomegesErtek(f.ertek, 'mind')">{{ f.rovid }}</ion-button>
                <ng-container *ngIf="isDualFokozatMode()">
                  <span class="cimke">Szorgalom:</span>
                  <ion-button *ngFor="let f of FOKOZAT_GOMBOK" size="small" fill="outline" color="tertiary"
                              (click)="tomegesErtek(f.ertek, 'mind', 'szorgalomodost')">{{ f.rovid }}</ion-button>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="kivalasztottOra?.osztalyozasimod !== '4' && !isDualFokozatMode()">
                <ion-input class="tomeges-mezo" type="number" [(ngModel)]="tomegesErtekMezo"
                           [placeholder]="kivalasztottOra?.osztalyozasimod === '2' ? '%' : '1-5'"
                           [min]="kivalasztottOra?.osztalyozasimod === '2' ? 0 : 1"
                           [max]="kivalasztottOra?.osztalyozasimod === '2' ? 100 : 5"></ion-input>
                <ion-button size="small" (click)="tomegesSzam('mind')">Mindenkinek</ion-button>
                <ion-button size="small" fill="outline" (click)="tomegesSzam('ures')"
                            [disabled]="!tomegesUresek">
                  Csak az üreseknek ({{ tomegesUresek }})
                </ion-button>
                <!-- NKP-eredmények: a bemásolt listából kitölti a névsort (százalék vagy ponthatáros jegy). -->
                <ion-button size="small" fill="outline" color="tertiary" (click)="nkpBeillesztes()"
                            title="A Nemzeti Köznevelési Portál eredménylistájának bemásolása">
                  <ion-icon slot="start" name="clipboard-outline"></ion-icon> NKP-eredmények beillesztése
                </ion-button>
                <!-- Aki nem írta meg: a jegyek beírása után a maradék egy lépésben „–”. -->
                <ion-button size="small" fill="outline" color="medium" *ngIf="nemIrtaLehet"
                            (click)="tomegesErtek(NEM_IRTA_JEL, 'ures')" [disabled]="!tomegesUresek"
                            title="Nem írta meg: az üresen maradt tanulók „–” jelet kapnak">
                  Üreseknek: – nem írta meg
                </ion-button>
              </ng-container>
              <ion-button size="small" fill="clear" color="medium" (click)="tomegesErtek('', 'mind')">
                Mindenkinél törlés
              </ion-button>
            </div>
                <div class="scrollable-table ertk-tabla-burok">
                  <table class="ertekeles ertk-tabla">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Név</th>
                        <th>09</th>
                        <th>10</th>
                        <th>11</th>
                        <th>12</th>
                        <th>01/I</th>
                        <th>I</th>
                        <th>Átlag</th>
                        <th>01/II</th>
                        <th>02</th>
                        <th>03</th>
                        <th>04</th>
                        <th>05</th>
                        <th>06</th>
                        <th>II</th>
                        <th>Átlag</th>
                        <th>Értékelés</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let n of kivalasztottOra.osztaly_nevsor; let j = index">
                        <tr [class.nevsor-rejtett]="!nevsorEgyezik(ertekelesNevSzuro, n)">
                          <td class="ertk-sorszam">{{j+1}}.</td>
                          <td class="ertk-nev"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="n.oktazon" [nev]="n.nev"></app-profilkep>{{n.nev}}</td>
                          <td class="ertk-honap" [attr.data-cimke]="h" *ngFor="let h of ['09','10','11','12','01/I']"><span
                              *ngFor="let item of kivalasztottOra.ertekelesek[n.oktazon]?.months[h]; let k = index">
                              <ion-button [attr.data-negyedev]="negyedevJel(item) || null" size="medium" fill="clear" [id]="'hover-trigger'+h+j+k" [class.negyedeves-jegy]="negyedevesE(item)" [class.nem-irta-jegy]="nemIrtaE(item)"
                                style="color:{{item.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)"><small *ngIf="negyedevesE(item)" class="negyedev-jel">{{negyedevJel(item)}}</small>{{jegyRovid(item)}}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container></ion-button>
                              <ion-popover [trigger]="'hover-trigger'+h+j+k" triggerAction="click" showBackdrop=false>
                                <ng-template>
                                  <ion-content class="ion-padding"><b>Téma:</b> {{item.tema}} <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – ha pótolta, a jegye a „Jegy beírása” gombbal kerül a helyére.</span><span
                                      *ngIf="item.ertekeles.length > 4"><br><b>Értékelés:</b>
                                      {{item.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(item.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                    {{item.targynap}}<br><b>Súlyozás:</b> {{item.szorzo}}%<br><b>Típus:</b>
                                    {{negyedevesE(item) ? negyedevNev(item) : item.emnev}}<span *ngIf="item.modositva"><br><b>Módosítva:</b> {{item.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><br><ion-button *ngIf="sajatTetel(item)" (click)="modositJegy(item)" size="small" fill="outline">{{ nemIrtaE(item) ? 'Jegy beírása' : 'Módosítás' }}</ion-button> <ion-button *ngIf="sajatTetel(item)" (click)="torolJegy(item)" size="small" color="danger">Stornó</ion-button></ion-content>
                                </ng-template>
                              </ion-popover></span></td>
                          <td class="ertk-felev" data-cimke="I. félév">
                            <span *ngFor="let fe of kivalasztottOra.ertekelesek[n.oktazon]?.felevi; let u = index">
                              <ion-button size="medium" fill="clear" [id]="'hover-trigger-felevi-'+u+j"
                                style="color:{{fe.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(fe)">
                                {{jegyRovid(fe)}}&nbsp;
                              </ion-button>
                              <ion-popover [trigger]="'hover-trigger-felevi-'+u+j" triggerAction="click"
                                showBackdrop=false>
                                <ng-template>
                                  <ion-content class="ion-padding"><b>Téma:</b> {{fe.tema}} <span
                                      *ngIf="fe.ertekeles.length > 4"><br><b>Értékelés:</b>
                                      {{fe.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(fe.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                    {{fe.targynap}}<br><b>Súlyozás:</b>
                                    {{fe.szorzo}}%<br><b>Típus:</b>
                                    {{fe.emnev}}<span *ngIf="fe.modositva"><br><b>Módosítva:</b> {{fe.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><br><ion-button *ngIf="sajatTetel(fe)" (click)="modositJegy(fe)" size="small" fill="outline">Módosítás</ion-button> <ion-button *ngIf="sajatTetel(fe)" (click)="torolJegy(fe)" size="small" color="danger">Stornó</ion-button></ion-content>
                                </ng-template>
                              </ion-popover>
                            </span>
                          </td>
                          <td class="ertk-atlag" data-cimke="Átlag (I)">
                            {{formatAtlag(kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekelesFelev, kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekelesFelevSzazalek)}}</td>
                          <td class="ertk-honap" [attr.data-cimke]="h" *ngFor="let h of ['01/II','02','03','04','05','06']"><span
                              *ngFor="let item of kivalasztottOra.ertekelesek[n.oktazon]?.months[h]; let k = index">
                              <ion-button [attr.data-negyedev]="negyedevJel(item) || null" size="medium" fill="clear" [id]="'hover-trigger'+h+j+k" [class.negyedeves-jegy]="negyedevesE(item)" [class.nem-irta-jegy]="nemIrtaE(item)"
                                style="color:{{item.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(item)"><small *ngIf="negyedevesE(item)" class="negyedev-jel">{{negyedevJel(item)}}</small>{{jegyRovid(item)}}<ng-container *ngIf="!negyedevesE(item)">&nbsp;</ng-container></ion-button>
                              <ion-popover [trigger]="'hover-trigger'+h+j+k" triggerAction="click" showBackdrop=false>
                                <ng-template>
                                  <ion-content class="ion-padding"><b>Téma:</b> {{item.tema}} <span *ngIf="nemIrtaE(item)"><br><b>Nem írta meg</b> – ha pótolta, a jegye a „Jegy beírása” gombbal kerül a helyére.</span><span
                                      *ngIf="item.ertekeles.length > 4"><br><b>Értékelés:</b>
                                      {{item.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(item.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                    {{item.targynap}}<br><b>Súlyozás:</b> {{item.szorzo}}%<br><b>Típus:</b>
                                    {{negyedevesE(item) ? negyedevNev(item) : item.emnev}}<span *ngIf="item.modositva"><br><b>Módosítva:</b> {{item.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><br><ion-button *ngIf="sajatTetel(item)" (click)="modositJegy(item)" size="small" fill="outline">{{ nemIrtaE(item) ? 'Jegy beírása' : 'Módosítás' }}</ion-button> <ion-button *ngIf="sajatTetel(item)" (click)="torolJegy(item)" size="small" color="danger">Stornó</ion-button></ion-content>
                                </ng-template>
                              </ion-popover></span></td>
                          <td class="ertk-felev" data-cimke="II. félév">
                            <span *ngFor="let ev of kivalasztottOra.ertekelesek[n.oktazon]?.evvegi; let u = index">
                              <ion-button size="medium" fill="clear" [id]="'hover-trigger-evvegi-'+u+j"
                                style="color:{{ev.szin}};--padding-start:0;--padding-end:0;margin:0" [title]="jegyHover(ev)">
                                {{jegyRovid(ev)}}&nbsp;
                              </ion-button>
                              <ion-popover [trigger]="'hover-trigger-evvegi-'+u+j" triggerAction="click"
                                showBackdrop=false>
                                <ng-template>
                                  <ion-content class="ion-padding"><b>Téma:</b> {{ev.tema}} <span
                                      *ngIf="ev.ertekeles.length > 4"><br><b>Értékelés:</b>
                                      {{ev.ertekeles}}</span><span *ngIf="getSpecialErtekelesReszletek(ev.ertekeles) as special"><br><b>Magatartás:</b> {{special.magatartas}}<br><b>Szorgalom:</b> {{special.szorgalom}}</span><br><b>Dátum:</b>
                                    {{ev.targynap}}<br><b>Súlyozás:</b>
                                    {{ev.szorzo}}%<br><b>Típus:</b>
                                    {{ev.emnev}}<span *ngIf="ev.modositva"><br><b>Módosítva:</b> {{ev.modositva | date:'yyyy.MM.dd. HH:mm'}}</span><br><ion-button *ngIf="sajatTetel(ev)" (click)="modositJegy(ev)" size="small" fill="outline">Módosítás</ion-button> <ion-button *ngIf="sajatTetel(ev)" (click)="torolJegy(ev)" size="small" color="danger">Stornó</ion-button></ion-content>
                                </ng-template>
                              </ion-popover>
                            </span>
                          </td>
                          <td class="ertk-atlag" data-cimke="Átlag (év)">
                            {{formatAtlag(kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekeles, kivalasztottOra.ertekelesek[n.oktazon]?.atlagErtekelesSzazalek)}}</td>
                          <td class="ertk-beiro">
                            <ng-container *ngIf="isDualFokozatMode(); else singleModeInput">
                              <div style="display:flex;flex-direction:column;gap:6px;padding:4px">
                                <div style="display:flex;gap:4px;align-items:center;flex-wrap:wrap">
                                  <span style="font-size:12px;min-width:22px">M:</span>
                                  <ion-button
                                    *ngFor="let f of FOKOZAT_GOMBOK"
                                    size="small"
                                    [fill]="kivalasztottOra.osztaly_nevsor[j].osztalyzat === f.ertek ? 'solid' : 'outline'"
                                    (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = f.ertek">
                                    {{f.rovid}}
                                  </ion-button>
                                  <ion-button
                                    size="small"
                                    fill="clear"
                                    color="medium"
                                    (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = ''">
                                    X
                                  </ion-button>
                                </div>
                                <div style="display:flex;gap:4px;align-items:center;flex-wrap:wrap">
                                  <span style="font-size:12px;min-width:22px">Sz:</span>
                                  <ion-button
                                    *ngFor="let f of FOKOZAT_GOMBOK"
                                    size="small"
                                    [fill]="kivalasztottOra.osztaly_nevsor[j].szorgalomodost === f.ertek ? 'solid' : 'outline'"
                                    (click)="kivalasztottOra.osztaly_nevsor[j].szorgalomodost = f.ertek">
                                    {{f.rovid}}
                                  </ion-button>
                                  <ion-button
                                    size="small"
                                    fill="clear"
                                    color="medium"
                                    (click)="kivalasztottOra.osztaly_nevsor[j].szorgalomodost = ''">
                                    X
                                  </ion-button>
                                </div>
                              </div>
                            </ng-container>
                            <ng-template #singleModeInput>
                              <ng-container *ngIf="kivalasztottOra?.osztalyozasimod === '4'; else szamInput">
                                <div style="display:flex;gap:4px;justify-content:center;align-items:center;padding:4px;flex-wrap:wrap">
                                  <ion-button
                                    *ngFor="let f of FOKOZAT_GOMBOK"
                                    size="small"
                                    [fill]="kivalasztottOra.osztaly_nevsor[j].osztalyzat === f.ertek ? 'solid' : 'outline'"
                                    (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = f.ertek">
                                    {{f.rovid}}
                                  </ion-button>
                                  <ion-button
                                    size="small"
                                    fill="clear"
                                    color="medium"
                                    (click)="kivalasztottOra.osztaly_nevsor[j].osztalyzat = ''">
                                    X
                                  </ion-button>
                                </div>
                              </ng-container>
                            </ng-template>
                            <ng-template #szamInput>
                              <!-- „NEM ÍRTA MEG” (–): jegy helyett mínusz annak, aki a dolgozatot nem írta meg.
                                   Nem jegy – az átlagba nem számít, a KRÉTÁ-ba nem megy; pótlás után a jegyre
                                   kattintva a „Jegy beírása” gombbal írható át. -->
                              <div class="jegy-beiro">
                                <!--  GOMBOK, NEM BEGÉPELÉS. Az érdemjegy öt értéket vehet fel;
                                      egy koppintás gyorsabb és nem lehet elgépelni. A már beírt
                                      jegy gombja kitöltött, újra megnyomva törlődik. Százalékos
                                      értékelésnél (mód 2) marad a szövegmező. -->
                                <div class="jegy-gombsor"
                                     *ngIf="jegyGombosMod(kivalasztottOra) && !nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat)">
                                  <ion-button *ngFor="let g of JEGY_GOMBOK" size="small"
                                    [fill]="jegyEgyezik(kivalasztottOra.osztaly_nevsor[j].osztalyzat, g) ? 'solid' : 'outline'"
                                    (click)="jegyGombra(kivalasztottOra.osztaly_nevsor[j], g)">{{ g }}</ion-button>
                                </div>
                                <ion-input *ngIf="!jegyGombosMod(kivalasztottOra) && !nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat)"
                                  type="number"
                                  [placeholder]="kivalasztottOra?.osztalyozasimod === '2' ? '%' : '1-5'"
                                  [min]="kivalasztottOra?.osztalyozasimod === '2' ? 0 : 1"
                                  [max]="kivalasztottOra?.osztalyozasimod === '2' ? 100 : 5"
                                  [(ngModel)]="kivalasztottOra.osztaly_nevsor[j].osztalyzat"></ion-input>
                                <span *ngIf="nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat)" class="nem-irta-cimke">nem írta meg</span>
                                <ion-button *ngIf="nemIrtaLehet" size="small" color="medium" class="nem-irta-gomb"
                                  [fill]="nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat) ? 'solid' : 'outline'"
                                  [title]="nemIrtaJelE(kivalasztottOra.osztaly_nevsor[j].osztalyzat) ? 'Kihúzás visszavonása' : 'Nem írta meg (–)'"
                                  (click)="nemIrtaValt(kivalasztottOra.osztaly_nevsor[j])">–</ion-button>
                              </div>
                            </ng-template>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
          </div>
        </ion-content>
        <!-- A MENTÉS a lábléc-sávban: mindig ugyanott, görgetéstől függetlenül. -->
        <ion-footer class="ertk-lablec">
          <ion-toolbar>
            <div class="ertk-lablec-sor">
              <span class="ertk-lablec-sugo" *ngIf="!kivalasztottOra.szam_tipus || !kivalasztottOra.osztalyozasimod">
                <ion-icon name="information-circle-outline" aria-hidden="true"></ion-icon>
                A mentéshez válaszd ki a számonkérés típusát és az osztályozási módot.
              </span>
              <ion-button size="medium" color="primary" (click)="saveErtekeles()"
                [disabled]="jegyMentesFolyamatban || !kivalasztottOra.szam_tipus || !kivalasztottOra.osztalyozasimod"
                class="ertk-mentes">{{ jegyMentesFolyamatban ? 'Mentés…' : 'Mentés' }}</ion-button>
            </div>
          </ion-toolbar>
        </ion-footer>
      </ng-container>
    </ng-template>
  </ion-modal>


  <ion-modal [class]="'nagy1'" #hazifeladatmodal>
    <ng-template>
      <ng-container>
        <ion-header>
          <ion-toolbar color="primary">
            <ion-title>Házi feladat melléklete</ion-title>
            <ion-buttons slot="end">
              <ion-button style="background: white;border-radius: 5px;" (click)="hazifeladatmodal.dismiss()"
                [strong]="true" shape="round" color="primary">Bezár</ion-button>
                <ion-button style="background: white;border-radius: 5px;" (click)="hazikuldes()"
                [strong]="true" shape="round" color="success">Mentés</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <div class="container" appDnd (fileDropped)="onFileDropped($event)">
            <input type="file"
              accept=".txt, .zip, .mp3, .mp4, .xlsx, .xls, .png, .jpeg, .jpg, .pdf, .docx, .doc, .ppt, .pptx, .svg"
              #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event)" />
            <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
              <g fill="#3B454F" fill-rule="nonzero">
                <path
                  d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                <path
                  d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                <path
                  d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
              </g>
            </svg>

            <h3>Húzza ide a fájlt</h3>
            <h3 style="    margin-bottom: 15px !important;">vagy</h3>
            <label for="fileDropRef">Tallózás</label>
          </div>
          <div class="files-list">
            <div class="single-file" *ngFor="let file of files; let i = index">
              <div class="file-icon" style="width: 50px">
                <img *ngIf="file?.name.slice(-3) == 'xls' ||file?.name.slice(-4) == 'xlsx'"
                  src="assets/svg/excel-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'pdf'" src="assets/svg/pdf-document-svgrepo-com.svg">
                <img
                  *ngIf="file?.name.slice(-4) == 'webp' ||file?.name.slice(-3) == 'svg' ||file?.name.slice(-3) == 'jpg' ||file?.name.slice(-3) == 'png' ||file?.name.slice(-4) == 'jpeg'"
                  src="assets/svg/image-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'mp3' ||file?.name.slice(-3) == 'mp4'"
                  src="assets/svg/video-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'zip'" src="assets/svg/zip-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'txt'" src="assets/svg/txt-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'ppt' ||file?.name.slice(-4) == 'pptx'"
                  src="assets/svg/ppt-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'doc' ||file?.name.slice(-4) == 'docx'"
                  src="assets/svg/word-document-svgrepo-com.svg">
              </div>
              <div class="info">
                <h4 class="name">
                  {{ file?.name }}
                </h4>
                <p class="size" *ngIf="file?.size">
                  {{ formatBytes(file?.size) }}
                </p>
                <app-progress *ngIf="file?.progress" [progress]="file?.progress"></app-progress>
              </div>

              <div class="delete" (click)="deleteFile(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                  <path fill="#B1B1B1" fill-rule="nonzero"
                    d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                </svg>
              </div>
            </div>
            Feltöltött fájlok:
            <div class="single-file" *ngFor="let file of regifajlok; let i = index">
              <div class="file-icon" style="width: 50px" (click)="openLink(file.Key)">
                <img *ngIf="file?.name.slice(-3) == 'xls' ||file?.name.slice(-4) == 'xlsx'"
                  src="assets/svg/excel-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'pdf'" src="assets/svg/pdf-document-svgrepo-com.svg">
                <img
                  *ngIf="file?.name.slice(-4) == 'webp' ||file?.name.slice(-3) == 'svg' ||file?.name.slice(-3) == 'jpg' ||file?.name.slice(-3) == 'png' ||file?.name.slice(-4) == 'jpeg'"
                  src="assets/svg/image-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'mp3' ||file?.name.slice(-3) == 'mp4'"
                  src="assets/svg/video-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'zip'" src="assets/svg/zip-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'txt'" src="assets/svg/txt-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'ppt' ||file?.name.slice(-4) == 'pptx'"
                  src="assets/svg/ppt-document-svgrepo-com.svg">
                <img *ngIf="file?.name.slice(-3) == 'doc' ||file?.name.slice(-4) == 'docx'"
                  src="assets/svg/word-document-svgrepo-com.svg">
              </div>
              <div class="info"  (click)="openLink(file.Key)">
                <h4 class="name">
                  {{ file?.name }}
                </h4>
              </div>

              <div class="delete" (click)="deleteRFile(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                  <path fill="#B1B1B1" fill-rule="nonzero"
                    d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                </svg>
              </div>
            </div>
          </div>



          <!--div class="custom-dropzone" ngx-dropzone [accept]="'*/*'" (change)="onSelect($event)">
	<ngx-dropzone-label>
		<div>
			<h2>Húzza ide a fájlt vagy kattintson!</h2>
		</div>
	</ngx-dropzone-label>
	<ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
		<ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
	</ngx-dropzone-image-preview>
</div-->
        </ion-content>
      </ng-container>
    </ng-template>
  </ion-modal>
  <!-- AZ ÓRA ELŐZMÉNYE (backend/ora-naplo.js): beírás, javítások, elmaradt-jelölés, törlés – ki, mikor, mit mire. -->
  <ion-modal [class]="'nagy1'" #elozmenymodal>
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-title>Előzmények – {{ elozmenyOra?.ora }}. óra {{ elozmenyOra?.osztaly || elozmenyOra?.csoport_nev }} {{ elozmenyOra?.tantargy }}</ion-title>
          <ion-buttons slot="end">
            <ion-button style="background: white;border-radius: 5px;" (click)="elozmenymodal.dismiss()"
              [strong]="true" shape="round" color="primary">Bezár</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <p *ngIf="elozmenyBetolt">Betöltés…</p>
        <ng-container *ngIf="elozmenyAdat as e">
          <p *ngIf="e.ora?.konyvelte">
            <b>Beírta:</b> {{ e.ora.konyvelte_nev || e.ora.konyvelte }}, {{ e.ora.konyvelve }}
          </p>
          <p *ngIf="e.ora?.elmaradt == 1"><b>Elmaradt</b><span *ngIf="e.ora.elmaradt_ok">: {{ e.ora.elmaradt_ok }}</span></p>
          <p *ngIf="!e.bejegyzesek?.length" class="halvany">Ehhez az órához még nincs naplóbejegyzés (a napló 2026. október 15-től vezetett).</p>
          <table class="elozmeny-tabla" *ngIf="e.bejegyzesek?.length">
            <thead><tr><th>Mikor</th><th>Ki</th><th>Mit</th><th>Változás</th></tr></thead>
            <tbody>
              <tr *ngFor="let b of e.bejegyzesek">
                <td class="nowrap">{{ b.ido }}</td>
                <td>{{ b.ki_nev || b.ki || '–' }}<span *ngIf="b.ki_valodi" class="halvany"><br>(nézetváltásban: {{ b.ki_valodi }})</span></td>
                <td>{{ MUVELET_NEV[b.muvelet] || b.muvelet }}<span *ngIf="b.megjegyzes" class="halvany"><br>{{ b.megjegyzes }}</span></td>
                <td>
                  <div *ngFor="let m of elozmenyMezok(b)">
                    <b>{{ MEZO_NEV[m] || m }}:</b>
                    <span class="regi">{{ elozmenyErtek(m, b.elotte && b.elotte[m]) }}</span> →
                    <span>{{ elozmenyErtek(m, b.utana && b.utana[m]) }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </ion-content>
    </ng-template>
  </ion-modal>
  <ion-alert header="Biztosan törli a kiválasztott beosztást?" [buttons]="alertButtons"></ion-alert>
  <ion-loading spinner="crescent" class="custom-loading" message="Mentés..."></ion-loading>
</ion-content>
